// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:22:54.059Z
// Property: The Leila Sweetwater (ID: 6767906449167444)
// Collections: 25 amenities, 3 floorplans (live), 226 photos, 37 POIs, 5 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167444",
  "property_external_id": "100160107",
  "property_zillow_url": "https://www.zillow.com/apartments/lithia-springs-ga/novo-sweetwater/Cf3S35/",
  "property_apartments_url": "https://www.apartments.com/novo-sweetwater-lithia-springs-ga/3xxmlgg/",
  "property_google_business_url": "https://www.google.com/maps/place/Novo+Sweetwater/data=!4m2!3m1!1s0x0:0xef456dfdab5e60b?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "56848929658",
  "property_crm_software": "Entrata LeadManager",
  "property_pm_software": "Entrata",
  "property_pm_info": "5605580",
  "property_status": null,
  "property_slug": "the-leila-sweetwater",
  "property_name": "The Leila Sweetwater",
  "property_website_url": "https://liveatnovosweetwater.com/",
  "property_domain": "https://theleilasweetwater.com/",
  "property_address": "1521 Lee Rd",
  "property_full_address": "1521 Lee Rd, Lithia Springs, GA 30122",
  "property_address_1": "1521 Lee Rd",
  "property_address_2": null,
  "property_address_city": "Lithia Springs",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30122",
  "property_address_country": "US",
  "property_address_county": "Douglas County",
  "property_neighborhood_address": "Outlying Douglas County",
  "property_address_latitude": "33.76550630000001",
  "property_address_longitude": "-84.6585862",
  "property_email": "theleilasweetwater@axiares.com",
  "property_phone": "(470) 444-4521",
  "property_call_tracking_phone": "2293035436",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "At NOVO Sweetwater in Lithia Springs, GA, luxury meets comfort in our stunning one, two, and three-bedroom apartments. Enjoy resort-style amenities like a sparkling swimming pool, a state-of-the-art fitness center, and beautifully landscaped courtyards. Elevate your lifestyle—browse available homes or schedule a tour today!",
  "property_long_description": "Luxury feels different when it feels like home. At The Leila Sweetwater, every detail has been thoughtfully designed to elevate your everyday living. Our spacious one, two, and three-bedroom apartment homes blend contemporary style with exceptional comfort, featuring granite countertops, stainless steel appliances, designer cabinetry, wood-style flooring, nine-foot ceilings, spacious layouts, and modern finishes that create a home you&#039;ll love coming back to.\r\nOutside your front door, discover amenities that inspire both relaxation and connection. Lounge beside the resort-style swimming pool, recharge in the state-of-the-art fitness center, unwind around the outdoor fireplace, gather with friends in inviting social spaces, or enjoy beautifully landscaped courtyards designed to make every day feel like a getaway. Even your four-legged companion has a place to play at the community bark park, while conveniences like garages, controlled access, and an AutoSpa make everyday living even easier.\r\n\r\nIdeally located in Lithia Springs with convenient access to I-20, Sweetwater Creek State Park, shopping, dining, entertainment, and major employers, NOVO Sweetwater offers the perfect balance of peaceful living and connected convenience. Whether you&#039;re heading into Atlanta, exploring the outdoors, or enjoying everything the neighborhood has to offer, you&#039;ll always be close to where you want to be.\r\nCome experience a community designed for the way you live today. Schedule your personal tour and discover why life feels better at The Leila Sweetwater.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-e373-7669-b3d6-8c4af59cbe3e.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury swimming pool area with lounge chairs and string lights at dusk",
    "public_id": "019d72d1-e373-7669-b3d6-8c4af59cbe3e",
    "storage_key": "property/6767906449167444/019d72d1-e373-7669-b3d6-8c4af59cbe3e.webp",
    "width": 1800,
    "height": 700
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "298",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "86.57718120805369",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security deposit: $500.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": "Please contact leasing office for more information.",
  "property_pet_policy_description": "Cats and dogs allowed, maximum 2 pets per unit. One-time pet fee: $350-$700. Monthly pet rent: $50 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://oll-leasing.loftliving.com/oll/?SiteId=5605580",
  "property_resident_portal_url": "https://theleilasweetwater.residentportal.com/auth",
  "property_apply_now_url": "https://theleilasweetwater.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160107/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-d3ed-77db-a774-f72522637d18.webp",
  "property_primary_logo_media": {
    "alt_text": "Hello Spring text with tulips and daisies.",
    "public_id": "019d72d1-d3ed-77db-a774-f72522637d18",
    "storage_key": "property/6767906449167444/019d72d1-d3ed-77db-a774-f72522637d18.webp",
    "width": 600,
    "height": 350
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78e5-2ed9-7771-abc9-ff1c2873ef11.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d78e5-2ed9-7771-abc9-ff1c2873ef11",
    "storage_key": "property/6767906449167444/019d78e5-2ed9-7771-abc9-ff1c2873ef11.webp",
    "width": 792,
    "height": 343
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78e5-2420-747e-9f5e-2b2da7d087a1.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d78e5-2420-747e-9f5e-2b2da7d087a1",
    "storage_key": "property/6767906449167444/019d78e5-2420-747e-9f5e-2b2da7d087a1.webp",
    "width": 792,
    "height": 343
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#47A23F",
  "property_secondary_color": "#f0f0f0",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": "#373A36",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "756 - 1248",
  "property_sqft_min": "756",
  "property_sqft_max": "1248",
  "property_price_range": "$1357 - $2853",
  "property_price_min": "1357",
  "property_price_max": "2853",
  "property_available_units": 40,
  "property_facebook_url": "https://www.facebook.com/people/Novo-Sweetwater/61556780912913/",
  "property_instagram_url": "https://www.instagram.com/novosweetwater/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ1euDObgh9YgRC-a12t9W9A4",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Lithia+Springs%2C+GA+30122",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to NOVO Sweetwater",
  "property_home_romance_title": "Embrace a New Chapter in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "Welcome to NOVO Sweetwater, where vibrant living meets modern luxury in Lithia Springs, GA. Choose from exquisite one, two, or three-bedroom floor plans, each featuring designer finishes and gourmet kitchens. Enjoy resort-style amenities like our sparkling pool, state-of-the-art fitness center, and tranquil green spaces—your serene lifestyle awaits!",
  "property_home_floorplans_blurb": "At NOVO Sweetwater in Lithia Springs, GA, your ideal living space awaits. Choose from thoughtfully designed one, two, or three-bedroom apartments, each tailored for comfort and style. Ready to elevate your lifestyle? Browse our available apartment homes today and discover the perfect floor plan that suits your unique needs.",
  "property_home_gallery_blurb": "Nestled in charming Lithia Springs, GA, NOVO Sweetwater elevates apartment living with exquisite one, two, and three-bedroom floor plans. Enjoy resort-style amenities like the sparkling swimming pool, state-of-the-art fitness center, and serene green spaces. Picture yourself unwinding by the outdoor fireplace or playing with your pup at our exclusive PupPlay Park!",
  "property_home_neighborhood_blurb": "Welcome to NOVO Sweetwater in Lithia Springs, GA, where spacious one, two, and three-bedroom floor plans harmonize with vibrant community life. Enjoy proximity to enriching spots like the South Cobb Regional Library and Sweetwater Creek State Park, ensuring both relaxation and adventure are right at your doorstep. Embrace a lifestyle that inspires!",
  "property_home_reviews_blurb": "At NOVO Sweetwater in Lithia Springs, GA, residents rave about the “welcoming atmosphere and spacious designs.” Embrace a lifestyle where comfort meets community. Transform your living experience today, and see what our residents have to say about their extraordinary home at NOVO Sweetwater!",
  "property_neighborhood_blurb": "Nestled in the heart of Lithia Springs, NOVO Sweetwater offers more than just stunning one, two, and three-bedroom floor plans. Enjoy the convenience of nearby attractions like Sweetwater Creek State Park, the Douglas County Museum of History and Art, and Falcon Stadium, all within reach. Uncover your vibrant new lifestyle today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At NOVO Sweetwater in Lithia Springs, GA, luxury meets comfort in our vibrant community. Enjoy the resort-inspired swimming pool, state-of-the-art fitness center, and lush green spaces. With modern finishes like granite counters and garden tubs, your new home is designed for relaxation and style. Embrace the life you deserve!",
  "property_applynow_blurb": "At NOVO Sweetwater in Lithia Springs, GA, life unfolds in beautifully designed one, two, and three-bedroom apartments, boasting granite counters and stainless steel appliances. Enjoy resort-style amenities like a sparkling swimming pool, state-of-the-art fitness center, and serene green spaces. Your ideal home awaits—lease online today!",
  "property_contactus_blurb": "At NOVO Sweetwater in Lithia Springs, GA, we offer spacious floor plans designed to suit every lifestyle, from cozy one-bedroom retreats to expansive three-bedroom homes. Each residence blends comfort and modern elegance. Curious about availability? Reach out to our leasing team today—your dream apartment awaits!",
  "property_faqs_blurb": "At NOVO Sweetwater in Lithia Springs, GA, choose the perfect floor plan for your lifestyle—whether it's a cozy one-bedroom, a spacious two-bedroom, or a luxurious three-bedroom. Navigate through our FAQs page to uncover everything you need to know about living in our vibrant community.",
  "property_floorplans_blurb": "At NOVO Sweetwater in Lithia Springs, GA, your ideal home awaits! Choose from our diverse range of one, two, and three-bedroom floor plans, perfectly designed to fit your lifestyle. Browse our available apartment homes today and let your journey to comfort and style begin!",
  "property_gallery_blurb": "At NOVO Sweetwater in Lithia Springs, GA, life unfolds amid luxurious amenities and stunning floor plans. Imagine soaking up sun by the resort-style pool or unwinding in your stylish three-bedroom haven. With beautifully landscaped courtyards and top-notch fitness facilities, picture yourself living in the vibrant community of your dreams! ",
  "property_interactivemap_blurb": "At NOVO Sweetwater in Lithia Springs, GA, luxury meets everyday living. Choose from thoughtfully designed one, two, or three-bedroom layouts, each featuring designer finishes and resort-style amenities. Enjoy sun-drenched relaxation by the pool, invigorating workouts in our fitness center, and cozy gatherings by the fire. Find your perfect home today through our interactive community map!",
  "property_pets_blurb": "Welcome to NOVO Sweetwater in Lithia Springs, GA, where your furry friends are part of the family! With ample space for two pets and an accessible pet policy, your home is just as cozy for them as it is for you. Embrace a vibrant lifestyle that truly accommodates everyone.",
  "property_referafriend_blurb": "At NOVO Sweetwater in Lithia Springs, GA, we offer spacious one, two, and three-bedroom floor plans tailored for every lifestyle. Share the joy of exceptional living with your friends—great friends make great neighbors. Refer a friend today and start building a vibrant community together!",
  "property_residentaccess_blurb": "Welcome to NOVO Sweetwater in Lithia Springs, GA! Our versatile floor plans feature one, two, and three-bedroom apartments tailored to your lifestyle. Access your resident portal today to effortlessly pay rent, schedule maintenance, and manage all your housing needs in one convenient place. Experience modern living at its finest!",
  "property_reviews_blurb": "At NOVO Sweetwater in Lithia Springs, GA, our residents rave about the vibrant community atmosphere, stating, “It's a great place to call home, with friendly neighbors and helpful staff.” Dive into our reviews and see why making NOVO Sweetwater your home is a decision you'll cherish!",
  "property_created_at": "1775747794206",
  "property_scheduletour_blurb": "At NOVO Sweetwater in Lithia Springs, GA, find your ideal space among our thoughtfully designed one, two, and three-bedroom floor plans. Experience the perfect blend of comfort and community—schedule a tour today and hear firsthand from residents who call this vibrant community home!",
  "property_thankyou_blurb": "Thank you for reaching out to NOVO Sweetwater in Lithia Springs, GA! Our diverse floor plans, ranging from cozy one bedrooms to spacious three bedrooms, cater to every lifestyle. A team member will be in touch soon to help you find your perfect home sweet home. Stay tuned!",
  "property_virtualtours_blurb": "Experience the charm of NOVO Sweetwater in Lithia Springs, GA! With thoughtfully designed one, two, and three-bedroom floor plans, your perfect home awaits. Step inside and envision your future—take a virtual tour of our community and apartments for rent today and see why NOVO Sweetwater is your ideal destination!",
  "property_copyright": "2026 All Rights Reserved. NOVO Sweetwater",
  "property_seo_title_home": "NOVO Sweetwater |  Apartments in Lithia Springs, GA",
  "property_seo_description_home": "Discover luxury at NOVO Sweetwater, Lithia Springs! Enjoy exquisite floor plans, resort-style amenities, and lush landscaping. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Lithia Springs, GA Apartments for Rent",
  "property_seo_description_floorplans": "Unlock your ideal living space at NOVO Sweetwater in Lithia Springs, GA. From cozy one-beds to spacious three-beds, there’s a floor plan tailored for you!",
  "property_seo_title_amenities": "Amenities | Lithia Springs, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at NOVO Sweetwater! Dive into resort-style amenities and elegant interiors in Lithia Springs, GA. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Lithia Springs, GA",
  "property_seo_description_gallery": "Picture yourself at NOVO Sweetwater in Lithia Springs, GA—luxury living with stunning amenities, elegant finishes, and a vibrant community awaits you!",
  "property_seo_title_virtualtours": "Virtual Tours | NOVO Sweetwater Apartments",
  "property_seo_description_virtualtours": "Step inside NOVO Sweetwater in Lithia Springs, GA! Explore one, two, and three-bedroom apartments with a virtual tour that showcases your future home!",
  "property_seo_title_interactivemap": "Interactive Map | NOVO Sweetwater Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at NOVO Sweetwater in Lithia Springs, GA! Explore stunning floor plans and top-notch amenities with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Lithia Springs, GA",
  "property_seo_description_neighborhood": "Uncover the charm of Lithia Springs at NOVO Sweetwater! From cozy cafes to scenic parks, experience local favorites just steps from your new home.",
  "property_seo_title_contact": "Contact Us | NOVO Sweetwater",
  "property_seo_description_contact": "Connect with NOVO Sweetwater in Lithia Springs, GA! From one to three-bedroom plans, our leasing team is ready to answer your questions. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Lithia Springs, GA",
  "property_seo_description_faqs": "Find answers to your questions about NOVO Sweetwater in Lithia Springs, GA! From luxury amenities to floor plans, we’ve got the details you need.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Lithia Springs, GA",
  "property_seo_description_reviews": "Experience NOVO Sweetwater in Lithia Springs, GA! From stunning amenities to spacious floor plans, see why our residents love calling this community home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Lithia Springs, GA",
  "property_seo_description_applynow": "Discover luxury living at NOVO Sweetwater in Lithia Springs, GA. Choose stylish floor plans with upscale amenities and a resort-style pool. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | NOVO Sweetwater",
  "property_seo_description_residentaccess": "Enjoy convenience at NOVO Sweetwater! Access your resident portal for easy rent payments, maintenance requests, and updates in Lithia Springs, GA.",
  "property_seo_title_referafriend": "Refer A Friend | NOVO Sweetwater",
  "property_seo_description_referafriend": "Refer a friend to NOVO Sweetwater in Lithia Springs, GA, and build memories with amazing neighbors in a vibrant community designed for connection and comfort!",
  "property_seo_title_scheduletour": "Schedule a Tour | NOVO Sweetwater",
  "property_seo_description_scheduletour": "Experience the charm of NOVO Sweetwater in Lithia Springs, GA. Schedule your tour today and envision your next adventure in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | NOVO Sweetwater",
  "property_seo_description_privacy": "At NOVO Sweetwater in Lithia Springs, GA, your privacy matters. Dive into our policy for insights on how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | NOVO Sweetwater",
  "property_seo_description_accessibility": "At NOVO Sweetwater in Lithia Springs, GA, we prioritize digital inclusion. Explore our commitment to accessibility and a welcoming community for all.",
  "property_seo_title_sitemap": "Sitemap | NOVO Sweetwater",
  "property_seo_description_sitemap": "Unravel the charm of NOVO Sweetwater in Lithia Springs, GA! Navigate our sitemap for a seamless journey to your new home sweet home.",
  "property_seo_title_thankyou": "Thank You | NOVO Sweetwater",
  "property_seo_description_thankyou": "Thank you for reaching out to NOVO Sweetwater in Lithia Springs! Our team will connect with you soon. Exciting apartment living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Lithia Springs, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793476119",
  "amenities": [
    {
      "id": "custom_23faffed-172e-4362-add8-7312dcf7443b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Inspired Swimming Pool with Sun Deck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa964667-de16-4b58-944e-4c086dd2bb26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Leasing and Management Team",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c5b97c1-4be4-46b7-bed7-982c18555782",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Service Team",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b49b8565-8b05-4344-863f-641bd9186400",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c0c20298-a055-4b5f-833f-88fd86848282",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "State‑of‑the‑Art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b51cedf-cd6d-48b1-b7be-c92c3e8c1506",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Free Weights",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d22bb78b-7822-445a-857a-6cf72b60e8cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Garages",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_586b8efc-d4f3-4c87-925a-3203e26a1b80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3653bd6b-f988-4c7d-b8db-134c785a1fb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access / Gated",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d73749f7-0b82-401f-9118-e6a2d6b2fb9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Centralized Mail Hub",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6c0486e2-3164-4512-94c9-fb9ef4a61c1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "PupPlay Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cba744ba-1510-45a8-8cbc-642acaccf7c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "AutoSpa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca1e30c0-d0e1-4e77-b996-c25ff59fbd1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Social Lounge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_87ad7f91-fe17-49f1-9f3f-984f6b7a6152",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Fireplace Lounge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6cd3a441-57a7-4aac-8ec6-b2fe3d8d9346",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Green Spaces and Beautifully Landscaped Courtyards",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c972696e-16cc-4008-9d25-adf4ba5cfc64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b570e3a-d319-40e9-a5ba-e20db6542f9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "42\" Shaker‑Style Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_22f1149e-f8cd-465a-8cc7-f1e51c60b032",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Counters",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e3f268d-d9a4-4a2b-8d70-3aa18e54fe87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Movable Kitchen Islands",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5fb27ce5-06ac-4b83-8a2e-1dfcbe8ce44b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "USB Outlets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_72307793-0cad-424a-8b63-e91b80504d1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Garden Tubs",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7fbbfe59-5d7a-4877-a894-a7ef43f0f0ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryers",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b2ff140-0bc2-4fe2-91a6-25e68f155c31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "9' Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76a61ceb-68fe-4d35-a73e-5f0f8168bef4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c63319d-3310-4557-90a0-5687f1c109ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Finishes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_259d19e4-442e-469f-971f-411793bc1307",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-3f23-75e8-9f54-14b971a85828.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and string lights at dusk.",
        "public_id": "019e02c4-3f23-75e8-9f54-14b971a85828",
        "storage_key": "property/6767906449167444/019e02c4-3f23-75e8-9f54-14b971a85828.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a cozy evening outdoors in our community's fire pit lounge area, complete with comfortable seating and ambient string lighting. Perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and string lights at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e12ae288-5a50-4247-be05-5ba3647b1718",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-4172-7081-8faa-719b1278e64a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and string lights at dusk.",
        "public_id": "019e02c4-4172-7081-8faa-719b1278e64a",
        "storage_key": "property/6767906449167444/019e02c4-4172-7081-8faa-719b1278e64a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and ambient string lights, perfect for evening enjoyment.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and string lights at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af39a900-02cc-4570-a79c-ab4b84a5eee5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-1df6-7179-87dc-156cc1582f0d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019e02c4-1df6-7179-87dc-156cc1582f0d",
        "storage_key": "property/6767906449167444/019e02c4-1df6-7179-87dc-156cc1582f0d.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and seating areas. Perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_690a9bbd-8c72-4dbb-8187-c9bce080c940",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-3b98-775d-aeba-ea072ef15dfe.webp",
      "image_media": {
        "alt_text": "Resort-style pool area with lounge chairs, fire pit, and outdoor TV, illuminated by string lights at dusk.",
        "public_id": "019e02c4-3b98-775d-aeba-ea072ef15dfe",
        "storage_key": "property/6767906449167444/019e02c4-3b98-775d-aeba-ea072ef15dfe.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy the resort-style pool and outdoor living spaces, complete with a fire pit and entertainment area. Perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Resort-style pool area with lounge chairs, fire pit, and outdoor TV, illuminated by string lights at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2ccb66c6-9300-4090-94f2-765b669da336",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-4116-75fe-81fa-ae41437bdfd3.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit, grills, and covered lounge.",
        "public_id": "019e02c4-4116-75fe-81fa-ae41437bdfd3",
        "storage_key": "property/6767906449167444/019e02c4-4116-75fe-81fa-ae41437bdfd3.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax by the fire pit or enjoy outdoor grilling in this beautifully appointed community space, complete with comfortable seating and ambient lighting.",
      "link": "",
      "alt_text": "Outdoor seating area with fire pit, grills, and covered lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc62d996-ff78-4c19-ab82-395c3381cd55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-10ad-70df-9602-86bb71aa6152.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with a parking lot in front.",
        "public_id": "019e02c4-10ad-70df-9602-86bb71aa6152",
        "storage_key": "property/6767906449167444/019e02c4-10ad-70df-9602-86bb71aa6152.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Experience modern living at our apartment community, featuring a stylish exterior and convenient amenities.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with a parking lot in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3534a202-9299-409a-8fbc-b81b250f95fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-3951-7438-a88a-e585d6da1e17.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, adjacent to a modern clubhouse at sunset.",
        "public_id": "019e02c4-3951-7438-a88a-e585d6da1e17",
        "storage_key": "property/6767906449167444/019e02c4-3951-7438-a88a-e585d6da1e17.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge chairs and private cabanas. Enjoy the beautiful sunset views from this prime community amenity.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, adjacent to a modern clubhouse at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc212aaa-9062-49f5-be3d-78b163c1eb18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-1799-764c-85f4-458c3f576a1d.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio area with blue sectional sofa, coffee table, and chairs.",
        "public_id": "019e02c4-1799-764c-85f4-458c3f576a1d",
        "storage_key": "property/6767906449167444/019e02c4-1799-764c-85f4-458c3f576a1d.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax on the comfortable outdoor seating or gather with friends at the patio tables. Enjoy the fresh air on this beautifully designed community space.",
      "link": "",
      "alt_text": "Outdoor covered patio area with blue sectional sofa, coffee table, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9cad0bcd-a98e-4f90-9049-b863a4e16fb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-1e50-734d-8d58-19b9010e1b7c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabana at dusk.",
        "public_id": "019e02c4-1e50-734d-8d58-19b9010e1b7c",
        "storage_key": "property/6767906449167444/019e02c4-1e50-734d-8d58-19b9010e1b7c.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana, perfect for enjoying warm days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabana at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_caaa2e68-569d-40d8-9885-19e919004c6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-fca2-72a2-ae79-46849ffbdd5d.webp",
      "image_media": {
        "alt_text": "Courtyard with fire pit, Adirondack chairs, hanging chairs, and string lights at apartment complex.",
        "public_id": "019e02c3-fca2-72a2-ae79-46849ffbdd5d",
        "storage_key": "property/6767906449167444/019e02c3-fca2-72a2-ae79-46849ffbdd5d.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor courtyard, featuring a cozy fire pit, comfortable seating, and charming string lights. Enjoy the fresh air and scenic mountain mural.",
      "link": "",
      "alt_text": "Courtyard with fire pit, Adirondack chairs, hanging chairs, and string lights at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b076ad9-6582-4217-ab5e-3bfe775afb9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c4-108c-763e-a5de-1d8e4b70e0ec.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower.",
        "public_id": "019e02c4-108c-763e-a5de-1d8e4b70e0ec",
        "storage_key": "property/6767906449167444/019e02c4-108c-763e-a5de-1d8e4b70e0ec.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "A clean and contemporary bathroom featuring a granite countertop vanity, a modern toilet, and a tiled shower, perfect for relaxing.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_abd5dc14-a73a-4a36-835a-d127967954c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-f732-70ea-a41c-a9fe30897c69.webp",
      "image_media": {
        "alt_text": "Novo Blue Ridge apartment building exterior with signage and landscaping.",
        "public_id": "019e02c3-f732-70ea-a41c-a9fe30897c69",
        "storage_key": "property/6767906449167444/019e02c3-f732-70ea-a41c-a9fe30897c69.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Discover modern living at Novo Blue Ridge, featuring stylish apartment exteriors and beautifully landscaped grounds.",
      "link": "",
      "alt_text": "Novo Blue Ridge apartment building exterior with signage and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3871e5d8-0551-4694-aada-9d5e5208e9d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-f9e5-754f-8701-02d8129e808d.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with multiple stories, balconies, and a parking lot.",
        "public_id": "019e02c3-f9e5-754f-8701-02d8129e808d",
        "storage_key": "property/6767906449167444/019e02c3-f9e5-754f-8701-02d8129e808d.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Modern apartment building exterior showcasing its design, balconies, and surrounding parking area. A perfect view of the property's facade and community appeal.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with multiple stories, balconies, and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_526402fe-bde5-492f-b31a-aab843b4cc42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-f726-7478-b027-1b8a520b8217.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, shower, and view of bedroom.",
        "public_id": "019e02c3-f726-7478-b027-1b8a520b8217",
        "storage_key": "property/6767906449167444/019e02c3-f726-7478-b027-1b8a520b8217.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience the spacious and modern bathrooms in our apartments, featuring elegant double vanities and walk-in showers. A glimpse into the bedroom offers a look at the inviting living spaces.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, shower, and view of bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3f0e9f49-d9a5-46e5-8006-a8cf176fa6d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-f020-775a-98d8-c19a78be4f3e.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with a parking lot and trees.",
        "public_id": "019e02c3-f020-775a-98d8-c19a78be4f3e",
        "storage_key": "property/6767906449167444/019e02c3-f020-775a-98d8-c19a78be4f3e.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Showcasing the modern exterior of the apartment building, complete with a spacious parking lot and lush green surroundings.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with a parking lot and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_602dafbb-293b-4724-ba1c-2e2fbc2b831b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-fea7-7669-846f-7e837fa8a968.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, cabanas, and an outdoor kitchen.",
        "public_id": "019e02c3-fea7-7669-846f-7e837fa8a968",
        "storage_key": "property/6767906449167444/019e02c3-fea7-7669-846f-7e837fa8a968.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by comfortable lounge chairs, private cabanas, and a fully equipped outdoor kitchen with seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs, cabanas, and an outdoor kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d95c66dc-072f-47ad-b431-7f828cadaf0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-f355-712a-93f9-d2e7d21c0f99.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with seating, tables, television, and grills.",
        "public_id": "019e02c3-f355-712a-93f9-d2e7d21c0f99",
        "storage_key": "property/6767906449167444/019e02c3-f355-712a-93f9-d2e7d21c0f99.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community's covered patio, complete with seating, dining tables, a television, and built-in grills for your convenience.",
      "link": "",
      "alt_text": "Outdoor covered patio with seating, tables, television, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2533df2e-6bb2-49dd-b457-1545a929b12e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-f30e-75b9-a1ae-c258c0c6eb11.webp",
      "image_media": {
        "alt_text": "A living room with a gray sofa, blue ottoman, and abstract art.",
        "public_id": "019e02c3-f30e-75b9-a1ae-c258c0c6eb11",
        "storage_key": "property/6767906449167444/019e02c3-f30e-75b9-a1ae-c258c0c6eb11.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Stylish living room with comfortable seating, modern decor, and ample natural light, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "A living room with a gray sofa, blue ottoman, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e6b02933-d5c7-49ba-9587-375d079cde70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-444d-728e-b5e0-e9a18ac7f99f.webp",
      "image_media": {
        "alt_text": "Two women smiling and holding a baby",
        "public_id": "019e02c3-444d-728e-b5e0-e9a18ac7f99f",
        "storage_key": "property/6767906449167444/019e02c3-444d-728e-b5e0-e9a18ac7f99f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "A loving family enjoying time together, embodying the warm and welcoming atmosphere of our community.",
      "link": "",
      "alt_text": "Two women smiling and holding a baby",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4894e6e-0584-4fd8-8277-5e170e8433f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-34b2-76c3-b997-4379114fd8bf.webp",
      "image_media": {
        "alt_text": "A couple prepares breakfast together in a bright, modern kitchen.",
        "public_id": "019e02c3-34b2-76c3-b997-4379114fd8bf",
        "storage_key": "property/6767906449167444/019e02c3-34b2-76c3-b997-4379114fd8bf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy vibrant mornings and delicious meals in your beautifully appointed apartment kitchen. Imagine starting your day with fresh ingredients and good company.",
      "link": "",
      "alt_text": "A couple prepares breakfast together in a bright, modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2eaf582-68aa-4ff4-807a-939aefa1692f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-093b-7568-ab93-23c4e65d216a.webp",
      "image_media": {
        "alt_text": "A happy family laughing and playing together on a sofa.",
        "public_id": "019e02c3-093b-7568-ab93-23c4e65d216a",
        "storage_key": "property/6767906449167444/019e02c3-093b-7568-ab93-23c4e65d216a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A joyful family moment, with parents and a child sharing laughter and playtime on a comfortable sofa, embodying the warm and welcoming atmosphere of home.",
      "link": "",
      "alt_text": "A happy family laughing and playing together on a sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_abd77020-4c17-4855-9665-03f5605e4dc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c2-eda9-771a-adac-7d2686219f1c.webp",
      "image_media": {
        "alt_text": "Two men petting a dog in a living room.",
        "public_id": "019e02c2-eda9-771a-adac-7d2686219f1c",
        "storage_key": "property/6767906449167444/019e02c2-eda9-771a-adac-7d2686219f1c.webp",
        "width": 3072,
        "height": 1296
      },
      "title": "Lifestyle",
      "description": "Enjoy a pet-friendly living experience with your furry companions. This image captures a warm moment between two residents and their dog in a stylish apartment.",
      "link": "",
      "alt_text": "Two men petting a dog in a living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_732c974b-b5c7-4e2e-a4a1-ecb5bbf31d27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c2-fddf-765d-b737-7e7b80567123.webp",
      "image_media": {
        "alt_text": "Woman tying her running shoes, sitting on a wooden deck outdoors.",
        "public_id": "019e02c2-fddf-765d-b737-7e7b80567123",
        "storage_key": "property/6767906449167444/019e02c2-fddf-765d-b737-7e7b80567123.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Lifestyle",
      "description": "A woman in athletic wear smiles as she ties her running shoes on a wooden deck, with trees and buildings in the background. Perfect for showcasing an active lifestyle.",
      "link": "",
      "alt_text": "Woman tying her running shoes, sitting on a wooden deck outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b262cfab-e8ff-4268-9bc3-57cb7327a60d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c2-ee5e-702c-8b32-2f01e9322d7d.webp",
      "image_media": {
        "alt_text": "Three friends enjoying wine on a balcony with a city view.",
        "public_id": "019e02c2-ee5e-702c-8b32-2f01e9322d7d",
        "storage_key": "property/6767906449167444/019e02c2-ee5e-702c-8b32-2f01e9322d7d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Friends gathered on a balcony, sharing a moment of laughter and conversation over glasses of wine. Enjoy the vibrant city skyline as your backdrop.",
      "link": "",
      "alt_text": "Three friends enjoying wine on a balcony with a city view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f424e1b-5061-48fa-9e51-6d7f4b3e0b89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-154c-7009-892d-d4d2b259ad32.webp",
      "image_media": {
        "alt_text": "Couple stretching outdoors.",
        "public_id": "019e02c3-154c-7009-892d-d4d2b259ad32",
        "storage_key": "property/6767906449167444/019e02c3-154c-7009-892d-d4d2b259ad32.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "A couple is seen stretching and exercising together in an outdoor setting. This image promotes an active and healthy lifestyle.",
      "link": "",
      "alt_text": "Couple stretching outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3bf43ce0-be14-4276-a6e9-3071006d422c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c3-11cb-7377-ad69-270ffa007973.webp",
      "image_media": {
        "alt_text": "People jumping into a swimming pool",
        "public_id": "019e02c3-11cb-7377-ad69-270ffa007973",
        "storage_key": "property/6767906449167444/019e02c3-11cb-7377-ad69-270ffa007973.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the community pool on a sunny day. Perfect for making memories!",
      "link": "",
      "alt_text": "People jumping into a swimming pool",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bef87a02-3d6b-478c-bb4d-515da1161a02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c2-f847-7193-a24c-434fb78c60ff.webp",
      "image_media": {
        "alt_text": "Dumbbells neatly arranged on a rack in a gym.",
        "public_id": "019e02c2-f847-7193-a24c-434fb78c60ff",
        "storage_key": "property/6767906449167444/019e02c2-f847-7193-a24c-434fb78c60ff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A well-equipped gym featuring rows of dumbbells, perfect for your fitness routine.",
      "link": "",
      "alt_text": "Dumbbells neatly arranged on a rack in a gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd18e09e-cca4-48ff-ad70-58f519b90c32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c2-ff08-7570-9c1b-018aaf4ed95f.webp",
      "image_media": {
        "alt_text": "A man with Down syndrome smiling while sharing a meal with a woman.",
        "public_id": "019e02c2-ff08-7570-9c1b-018aaf4ed95f",
        "storage_key": "property/6767906449167444/019e02c2-ff08-7570-9c1b-018aaf4ed95f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "Enjoy a meal with loved ones. Our community fosters connection and belonging for all residents.",
      "link": "",
      "alt_text": "A man with Down syndrome smiling while sharing a meal with a woman.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec13f72d-5220-4b33-9ef9-cd2200af486b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c2-f09e-71e8-900e-641aecec4e77.webp",
      "image_media": {
        "alt_text": "Couple assembling furniture in apartment",
        "public_id": "019e02c2-f09e-71e8-900e-641aecec4e77",
        "storage_key": "property/6767906449167444/019e02c2-f09e-71e8-900e-641aecec4e77.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A young couple happily assembling new furniture together in their apartment, showcasing a sense of home and shared activity.",
      "link": "",
      "alt_text": "Couple assembling furniture in apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d49442e-fcc6-4dbe-8102-0feb8435346d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019e02c2-f438-746e-8ca3-fe1730ec2846.webp",
      "image_media": {
        "alt_text": "People enjoying a backyard barbecue with string lights and colorful flags overhead.",
        "public_id": "019e02c2-f438-746e-8ca3-fe1730ec2846",
        "storage_key": "property/6767906449167444/019e02c2-f438-746e-8ca3-fe1730ec2846.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Residents gather for a summer barbecue, creating a vibrant and social atmosphere. Enjoy community events and connect with neighbors in this lively setting.",
      "link": "",
      "alt_text": "People enjoying a backyard barbecue with string lights and colorful flags overhead.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c18b8be2-52f9-407e-89e7-54c7bfe4adf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889e-1078-73b3-a108-63d3d993dc61.webp",
      "image_media": {
        "alt_text": "People jumping into a swimming pool with inflatable rings.",
        "public_id": "019d889e-1078-73b3-a108-63d3d993dc61",
        "storage_key": "property/6767906449167444/019d889e-1078-73b3-a108-63d3d993dc61.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Lifestyle",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool. Perfect for a hot summer day!",
      "link": "",
      "alt_text": "People jumping into a swimming pool with inflatable rings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_742083e4-8290-4d7a-a6c4-4660bdc8f48b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889e-0e78-72f4-b2a3-2ba7a19c379f.webp",
      "image_media": {
        "alt_text": "Woman tying her running shoes outdoors.",
        "public_id": "019d889e-0e78-72f4-b2a3-2ba7a19c379f",
        "storage_key": "property/6767906449167444/019d889e-0e78-72f4-b2a3-2ba7a19c379f.webp",
        "width": 1280,
        "height": 850
      },
      "title": "Lifestyle",
      "description": "A woman is tying her running shoes, ready for a workout. Lifestyle amenities and an active community await.",
      "link": "",
      "alt_text": "Woman tying her running shoes outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_88639ebb-e30c-40ad-b759-d19ce4e88450",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889d-fee7-757e-bd17-93b9ca59dec0.webp",
      "image_media": {
        "alt_text": "People enjoying an outdoor BBQ party with drinks and music.",
        "public_id": "019d889d-fee7-757e-bd17-93b9ca59dec0",
        "storage_key": "property/6767906449167444/019d889d-fee7-757e-bd17-93b9ca59dec0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Lifestyle",
      "description": "Experience vibrant community living with outdoor gatherings, BBQs, and music. Perfect for socializing and making memories.",
      "link": "",
      "alt_text": "People enjoying an outdoor BBQ party with drinks and music.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a04205d7-7757-466d-93f5-59ca6dbed76e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889e-000f-744c-8d37-3bd1e23aa669.webp",
      "image_media": {
        "alt_text": "Three friends enjoying wine on a balcony with a city view.",
        "public_id": "019d889e-000f-744c-8d37-3bd1e23aa669",
        "storage_key": "property/6767906449167444/019d889e-000f-744c-8d37-3bd1e23aa669.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Lifestyle",
      "description": "Friends gather on a balcony, sharing drinks and laughter, enjoying a beautiful city skyline. Perfect for apartment living and community events.",
      "link": "",
      "alt_text": "Three friends enjoying wine on a balcony with a city view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a0bb140-2228-4fee-b31d-1a409531d7d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889e-005c-75eb-a293-8f32d008c57b.webp",
      "image_media": {
        "alt_text": "Couple preparing breakfast in a bright kitchen",
        "public_id": "019d889e-005c-75eb-a293-8f32d008c57b",
        "storage_key": "property/6767906449167444/019d889e-005c-75eb-a293-8f32d008c57b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Lifestyle",
      "description": "Enjoy the vibrant atmosphere of your new home with loved ones, making memories in a beautiful kitchen. The perfect place to start your day.",
      "link": "",
      "alt_text": "Couple preparing breakfast in a bright kitchen",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de39f2f3-4cfa-4ed7-ad0a-1b80ea950b9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889d-fe0d-7129-8528-c4659531adfb.webp",
      "image_media": {
        "alt_text": "Family playing on a couch, laughing and smiling.",
        "public_id": "019d889d-fe0d-7129-8528-c4659531adfb",
        "storage_key": "property/6767906449167444/019d889d-fe0d-7129-8528-c4659531adfb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Lifestyle",
      "description": "A happy family enjoying quality time together in their comfortable living space.",
      "link": "",
      "alt_text": "Family playing on a couch, laughing and smiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51d99147-0f37-4397-8254-33aea4d51524",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889d-fdf4-724e-a433-543956d36548.webp",
      "image_media": {
        "alt_text": "A man and woman with prosthetic legs stretching outdoors.",
        "public_id": "019d889d-fdf4-724e-a433-543956d36548",
        "storage_key": "property/6767906449167444/019d889d-fdf4-724e-a433-543956d36548.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Lifestyle",
      "description": "Active residents with prosthetic limbs engage in a stretching routine, embodying a healthy and inclusive lifestyle.",
      "link": "",
      "alt_text": "A man and woman with prosthetic legs stretching outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35d32b8e-1157-45ca-b027-dfcb9ca867c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889e-0003-730a-814a-7ef935e3bacc.webp",
      "image_media": {
        "alt_text": "Man with Down syndrome smiling during a meal with a woman",
        "public_id": "019d889e-0003-730a-814a-7ef935e3bacc",
        "storage_key": "property/6767906449167444/019d889e-0003-730a-814a-7ef935e3bacc.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Lifestyle",
      "description": "A heartwarming scene of a man with Down syndrome sharing a meal and laughter with a woman, highlighting community and inclusion.",
      "link": "",
      "alt_text": "Man with Down syndrome smiling during a meal with a woman",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59c15027-71f9-4abc-837d-4b8903f9e148",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889e-0013-728a-9d47-6926b40f4ba9.webp",
      "image_media": {
        "alt_text": "Two women and a baby smiling and hugging.",
        "public_id": "019d889e-0013-728a-9d47-6926b40f4ba9",
        "storage_key": "property/6767906449167444/019d889e-0013-728a-9d47-6926b40f4ba9.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Lifestyle",
      "description": "A happy family enjoying their time together in their apartment.",
      "link": "",
      "alt_text": "Two women and a baby smiling and hugging.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_486f7c29-43b6-421f-824f-7ed0e6dc3182",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889d-fdea-731b-888c-d7c5364435b2.webp",
      "image_media": {
        "alt_text": "Row of dumbbells in a gym",
        "public_id": "019d889d-fdea-731b-888c-d7c5364435b2",
        "storage_key": "property/6767906449167444/019d889d-fdea-731b-888c-d7c5364435b2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A neat row of dumbbells in a gym, ready for a workout. Part of the community amenities.",
      "link": "",
      "alt_text": "Row of dumbbells in a gym",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b82a6ae-78db-4373-9b0a-6abf9e788cd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889d-feda-77dc-ad93-1ff181bfb190.webp",
      "image_media": {
        "alt_text": "Couple assembling furniture in their new apartment.",
        "public_id": "019d889d-feda-77dc-ad93-1ff181bfb190",
        "storage_key": "property/6767906449167444/019d889d-feda-77dc-ad93-1ff181bfb190.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Lifestyle",
      "description": "A couple happily assembling new furniture in their apartment, signifying the start of a new chapter.",
      "link": "",
      "alt_text": "Couple assembling furniture in their new apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7b85360a-112a-44d3-bf72-f66de12b0f1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d889d-fddf-73d4-9afb-7aaf45955788.webp",
      "image_media": {
        "alt_text": "Two men petting their dog in a sunlit living room.",
        "public_id": "019d889d-fddf-73d4-9afb-7aaf45955788",
        "storage_key": "property/6767906449167444/019d889d-fddf-73d4-9afb-7aaf45955788.webp",
        "width": 1280,
        "height": 540
      },
      "title": "Lifestyle",
      "description": "Enjoy a cozy evening with your furry friend in your new apartment. Pet-friendly living at its finest.",
      "link": "",
      "alt_text": "Two men petting their dog in a sunlit living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fde72ffc-92c7-4b03-8683-3575b7840b1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-97f3-7639-b260-de47af5e925b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabanas at a multifamily property.",
        "public_id": "019d78f6-97f3-7639-b260-de47af5e925b",
        "storage_key": "property/6767906449167444/019d78f6-97f3-7639-b260-de47af5e925b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded cabanas for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabanas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb84f77c-960b-463b-a299-84cc0f3874c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-964c-778f-ab34-349834e345af.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with cornhole game and seating.",
        "public_id": "019d78f6-964c-778f-ab34-349834e345af",
        "storage_key": "property/6767906449167444/019d78f6-964c-778f-ab34-349834e345af.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor games and relaxation in our community's beautifully landscaped lounge area, complete with cornhole and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor lounge area with cornhole game and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_75852bf7-78e8-4a88-bd7b-d4234cdb83f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-9a35-766a-a398-bf83a8b57479.webp",
      "image_media": {
        "alt_text": "Office area with manager and assistant manager doors, a desk, and artwork.",
        "public_id": "019d78f6-9a35-766a-a398-bf83a8b57479",
        "storage_key": "property/6767906449167444/019d78f6-9a35-766a-a398-bf83a8b57479.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "This image showcases the office area, featuring a desk with a computer and chair, as well as signs for 'Manager' and 'Assistant Manager'.",
      "link": "",
      "alt_text": "Office area with manager and assistant manager doors, a desk, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_80813580-dfc4-4eec-be19-7445a60bc74a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-94cd-749b-ae4b-4c5f2c16fdd1.webp",
      "image_media": {
        "alt_text": "Outdoor daybed with canopy and curtains, hammock, and chairs in a grassy courtyard.",
        "public_id": "019d78f6-94cd-749b-ae4b-4c5f2c16fdd1",
        "storage_key": "property/6767906449167444/019d78f6-94cd-749b-ae4b-4c5f2c16fdd1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor spaces, complete with comfortable daybeds, hammocks, and seating areas perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor daybed with canopy and curtains, hammock, and chairs in a grassy courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e7c117d-2bd3-4dda-a6a4-1bbfa8e5caa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-90c5-72a1-b2a8-cee3e593d702.webp",
      "image_media": {
        "alt_text": "Outdoor patio with a fire pit, chairs, and a hammock.",
        "public_id": "019d78f6-90c5-72a1-b2a8-cee3e593d702",
        "storage_key": "property/6767906449167444/019d78f6-90c5-72a1-b2a8-cee3e593d702.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor lounge area, complete with a cozy fire pit, comfortable seating, and a hammock for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor patio with a fire pit, chairs, and a hammock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_64e39f6a-7821-4d4d-ab37-8de0ca73c048",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-8e21-727e-9687-1e04b93ceaa6.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and cabanas on a sunny day.",
        "public_id": "019d78f6-8e21-727e-9687-1e04b93ceaa6",
        "storage_key": "property/6767906449167444/019d78f6-8e21-727e-9687-1e04b93ceaa6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating areas. Perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and cabanas on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd4f4300-7562-45c1-a588-010611609ae3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-897c-774a-becd-5d353a761bf1.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with sinks, countertops, and a large screen television mounted above.",
        "public_id": "019d78f6-897c-774a-becd-5d353a761bf1",
        "storage_key": "property/6767906449167444/019d78f6-897c-774a-becd-5d353a761bf1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy cooking and entertaining outdoors with this well-equipped outdoor kitchen, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor kitchen area with sinks, countertops, and a large screen television mounted above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_09ae7879-0e00-431a-805b-461de5898503",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-891f-752d-9c9d-36fa3cfec7ce.webp",
      "image_media": {
        "alt_text": "Outdoor grill with a built-in kitchen counter and seating area, next to a swimming pool.",
        "public_id": "019d78f6-891f-752d-9c9d-36fa3cfec7ce",
        "storage_key": "property/6767906449167444/019d78f6-891f-752d-9c9d-36fa3cfec7ce.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our community's built-in grills and ample seating, perfect for gathering with friends and neighbors by the pool.",
      "link": "",
      "alt_text": "Outdoor grill with a built-in kitchen counter and seating area, next to a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6b17538-0b10-4624-bd2f-46bbc0799bf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-885b-714f-b09d-fdc523162a76.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with two grills and a pool in the background.",
        "public_id": "019d78f6-885b-714f-b09d-fdc523162a76",
        "storage_key": "property/6767906449167444/019d78f6-885b-714f-b09d-fdc523162a76.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our state-of-the-art grilling stations, located conveniently near the sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor kitchen area with two grills and a pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_01ed121b-b408-42b3-b232-cb294918bb9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-8620-75b0-92b0-f819c41ea38a.webp",
      "image_media": {
        "alt_text": "Ping pong table and outdoor seating area with pool in background",
        "public_id": "019d78f6-8620-75b0-92b0-f819c41ea38a",
        "storage_key": "property/6767906449167444/019d78f6-8620-75b0-92b0-f819c41ea38a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy friendly competition at the ping pong table or relax by the sparkling pool in this vibrant community space.",
      "link": "",
      "alt_text": "Ping pong table and outdoor seating area with pool in background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15666036-d6b0-401d-8881-a6034f2c91ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-89e5-753d-b931-86a762d5901c.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with sink, countertops, and a television.",
        "public_id": "019d78f6-89e5-753d-b931-86a762d5901c",
        "storage_key": "property/6767906449167444/019d78f6-89e5-753d-b931-86a762d5901c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy cooking and entertaining outdoors with this fully equipped outdoor kitchen featuring a sink, spacious countertops, and a large television for entertainment.",
      "link": "",
      "alt_text": "Outdoor kitchen with sink, countertops, and a television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e95334c-e0b5-49e5-ac17-c4aac40a130f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-85f7-73da-bab4-0b8940e3e7c5.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with seating and pool view.",
        "public_id": "019d78f6-85f7-73da-bab4-0b8940e3e7c5",
        "storage_key": "property/6767906449167444/019d78f6-85f7-73da-bab4-0b8940e3e7c5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the outdoors with comfortable seating on the covered patio overlooking the pool. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Covered outdoor patio with seating and pool view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f38676ac-3419-494a-96d9-a54c5379982c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-83f0-747a-9709-3ab43cfbb087.webp",
      "image_media": {
        "alt_text": "Community kitchen area with large island and seating, stainless steel appliances and modern decor.",
        "public_id": "019d78f6-83f0-747a-9709-3ab43cfbb087",
        "storage_key": "property/6767906449167444/019d78f6-83f0-747a-9709-3ab43cfbb087.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Gather around the expansive island in the community kitchen, perfect for entertaining or casual meals. Features modern appliances and stylish seating.",
      "link": "",
      "alt_text": "Community kitchen area with large island and seating, stainless steel appliances and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb5f1a1c-f805-43df-9566-92ee275961ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-861e-77d3-88b0-bc0195afc62c.webp",
      "image_media": {
        "alt_text": "Lounge area with pool table, bar, and seating.",
        "public_id": "019d78f6-861e-77d3-88b0-bc0195afc62c",
        "storage_key": "property/6767906449167444/019d78f6-861e-77d3-88b0-bc0195afc62c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the community lounge, complete with a pool table, bar area, and comfortable seating for relaxation and socializing.",
      "link": "",
      "alt_text": "Lounge area with pool table, bar, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f8af57d7-2b3b-445b-a1e2-7e1671ad094e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-7d53-754b-a110-17cf40a99394.webp",
      "image_media": {
        "alt_text": "Community lounge area with a large live-edge dining table and seating, a full-size refrigerator, and a stylish blue brick backsplash.",
        "public_id": "019d78f6-7d53-754b-a110-17cf40a99394",
        "storage_key": "property/6767906449167444/019d78f6-7d53-754b-a110-17cf40a99394.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Gather in our stylish community lounge, featuring a large live-edge dining table perfect for meetings or social events. Includes a full-size refrigerator and a modern blue brick backsplash.",
      "link": "",
      "alt_text": "Community lounge area with a large live-edge dining table and seating, a full-size refrigerator, and a stylish blue brick backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_931632d9-4e8d-401e-b8e2-ffb19460b3d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-7c84-7238-99b2-263fcfb805ca.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, accent chairs, coffee table, and a wall-mounted TV.",
        "public_id": "019d78f6-7c84-7238-99b2-263fcfb805ca",
        "storage_key": "property/6767906449167444/019d78f6-7c84-7238-99b2-263fcfb805ca.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish living area, perfect for entertaining guests or enjoying a quiet evening in.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, accent chairs, coffee table, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b4133c2-9a72-4535-9628-4ab647134393",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-79d4-712a-841d-7ea22fd4712d.webp",
      "image_media": {
        "alt_text": "A well-lit community room with a pool table, lounge seating, and a small kitchenette.",
        "public_id": "019d78f6-79d4-712a-841d-7ea22fd4712d",
        "storage_key": "property/6767906449167444/019d78f6-79d4-712a-841d-7ea22fd4712d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our resident lounge featuring a billiards table, comfortable seating areas, and a convenient kitchenette for social gatherings.",
      "link": "",
      "alt_text": "A well-lit community room with a pool table, lounge seating, and a small kitchenette.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3e01491-8e4e-4ab3-a31a-3526b4ccce9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-783f-765f-a3ce-4416628a9b2c.webp",
      "image_media": {
        "alt_text": "Community lounge area with marble-top tables, comfortable seating, and a coffee station.",
        "public_id": "019d78f6-783f-765f-a3ce-4416628a9b2c",
        "storage_key": "property/6767906449167444/019d78f6-783f-765f-a3ce-4416628a9b2c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and recharge in our inviting community lounge, complete with a complimentary coffee bar and ample seating for work or socializing.",
      "link": "",
      "alt_text": "Community lounge area with marble-top tables, comfortable seating, and a coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b3e1ee2-ba7c-4830-be51-990c8d241415",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-74b3-703e-ab83-e0ad93a8abe9.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with weight racks, benches, treadmills, and rowing machines.",
        "public_id": "019d78f6-74b3-703e-ab83-e0ad93a8abe9",
        "storage_key": "property/6767906449167444/019d78f6-74b3-703e-ab83-e0ad93a8abe9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring top-of-the-line equipment for all your workout needs.",
      "link": "",
      "alt_text": "Well-equipped fitness center with weight racks, benches, treadmills, and rowing machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1002aa7b-4d48-48a5-90c7-3b6beff690d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-74f7-73fe-8bb1-950f581e5269.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment building lobby with a seating area, tables, and a view of the pool through the doors.",
        "public_id": "019d78f6-74f7-73fe-8bb1-950f581e5269",
        "storage_key": "property/6767906449167444/019d78f6-74f7-73fe-8bb1-950f581e5269.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the spacious and well-appointed lobby area, perfect for relaxing or working. Large doors offer a view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Interior of a modern apartment building lobby with a seating area, tables, and a view of the pool through the doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8fd0813-3099-408a-986c-55ebf54a9905",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-74a3-77c2-94f3-8a0d2f4c7fe8.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, free weights, and benches overlooking scenic outdoor views.",
        "public_id": "019d78f6-74a3-77c2-94f3-8a0d2f4c7fe8",
        "storage_key": "property/6767906449167444/019d78f6-74a3-77c2-94f3-8a0d2f4c7fe8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring top-tier cardio equipment, a comprehensive free weight selection, and versatile weight benches. Enjoy your workout with a view of the surrounding natural beauty.",
      "link": "",
      "alt_text": "Well-equipped fitness center with cardio machines, free weights, and benches overlooking scenic outdoor views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3d9923d8-897d-45e4-bd43-5044b0788fbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-74a4-7639-b52c-8cff4363845e.webp",
      "image_media": {
        "alt_text": "Gym equipment including stationary bikes, treadmills, and weight machines, with large mirrors and bright lighting.",
        "public_id": "019d78f6-74a4-7639-b52c-8cff4363845e",
        "storage_key": "property/6767906449167444/019d78f6-74a4-7639-b52c-8cff4363845e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Fully equipped fitness center with cardio machines, free weights, and mirrored walls for your workout needs.",
      "link": "",
      "alt_text": "Gym equipment including stationary bikes, treadmills, and weight machines, with large mirrors and bright lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7b0e686a-7266-4e72-a1e8-eeed4ee6efda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-74c3-7604-ac61-c3d4322a1e71.webp",
      "image_media": {
        "alt_text": "Seating area with tables and chairs in a community lounge with view of pool through glass doors.",
        "public_id": "019d78f6-74c3-7604-ac61-c3d4322a1e71",
        "storage_key": "property/6767906449167444/019d78f6-74c3-7604-ac61-c3d4322a1e71.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax in the stylish community lounge, featuring comfortable seating, modern decor, and a view of the sparkling pool.",
      "link": "",
      "alt_text": "Seating area with tables and chairs in a community lounge with view of pool through glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8a49cd48-0797-40e9-ad64-294fb1f22a97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-70ae-71e8-b8b0-670b4c416ee5.webp",
      "image_media": {
        "alt_text": "Gym with weight training equipment, treadmills, ellipticals, and stair climbers.",
        "public_id": "019d78f6-70ae-71e8-b8b0-670b4c416ee5",
        "storage_key": "property/6767906449167444/019d78f6-70ae-71e8-b8b0-670b4c416ee5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a wide variety of cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Gym with weight training equipment, treadmills, ellipticals, and stair climbers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b57717d9-7155-464d-9991-9ce567ecd365",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-6511-72bc-b21f-8154796c2090.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stair climbers, free weights, and a TRX training rig.",
        "public_id": "019d78f6-6511-72bc-b21f-8154796c2090",
        "storage_key": "property/6767906449167444/019d78f6-6511-72bc-b21f-8154796c2090.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of cardio machines, free weights, and functional training equipment to help you stay active and healthy.",
      "link": "",
      "alt_text": "Fitness center with treadmills, stair climbers, free weights, and a TRX training rig.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b93d152e-728b-4ed2-9ee7-b8c13bbe07f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-6965-70f3-b3ae-28b37e4a9c35.webp",
      "image_media": {
        "alt_text": "Street view of a modern apartment complex with white and dark gray buildings.",
        "public_id": "019d78f6-6965-70f3-b3ae-28b37e4a9c35",
        "storage_key": "property/6767906449167444/019d78f6-6965-70f3-b3ae-28b37e4a9c35.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "A picturesque street lined with modern apartment buildings, featuring a mix of white and dark gray facades, set against a backdrop of trees and a bright blue sky.",
      "link": "",
      "alt_text": "Street view of a modern apartment complex with white and dark gray buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6363df25-e480-4e0f-8355-3b02a99e9538",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-627f-733c-a131-5abfc6d54a21.webp",
      "image_media": {
        "alt_text": "Mailboxes and fire extinguisher on building exterior",
        "public_id": "019d78f6-627f-733c-a131-5abfc6d54a21",
        "storage_key": "property/6767906449167444/019d78f6-627f-733c-a131-5abfc6d54a21.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Secure mailboxes are conveniently located on the exterior of the building for easy resident access.",
      "link": "",
      "alt_text": "Mailboxes and fire extinguisher on building exterior",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d15287ed-fff6-47bd-a60d-ca5036153f08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-6445-7078-abe4-d7f89af6a7b4.webp",
      "image_media": {
        "alt_text": "Exterior of the community building with parking lot in foreground",
        "public_id": "019d78f6-6445-7078-abe4-d7f89af6a7b4",
        "storage_key": "property/6767906449167444/019d78f6-6445-7078-abe4-d7f89af6a7b4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern community building exterior with ample parking and landscaping. A welcoming entrance to the property.",
      "link": "",
      "alt_text": "Exterior of the community building with parking lot in foreground",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e309b43e-a575-429c-b363-3cb37ef07ede",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-5328-754d-ab7b-fad25997db6a.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and surrounding trees.",
        "public_id": "019d78f6-5328-754d-ab7b-fad25997db6a",
        "storage_key": "property/6767906449167444/019d78f6-5328-754d-ab7b-fad25997db6a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, perfect for your furry friends to play and socialize. Features include agility equipment and a fenced-in area.",
      "link": "",
      "alt_text": "Dog park with agility equipment and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a37a8bbf-a5ce-471d-8584-27d603a967ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-52b4-7648-83ea-9d0503450d23.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a mural on a building.",
        "public_id": "019d78f6-52b4-7648-83ea-9d0503450d23",
        "storage_key": "property/6767906449167444/019d78f6-52b4-7648-83ea-9d0503450d23.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in the outdoor seating area, adorned with a beautiful mural, perfect for enjoying the community's ambiance.",
      "link": "",
      "alt_text": "Outdoor seating area with a mural on a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c218968-d8c1-4ba7-bd2d-ab76768f3679",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-51eb-7209-99f9-64bcc2818912.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with Adirondack chairs and a mural on the side of a building.",
        "public_id": "019d78f6-51eb-7209-99f9-64bcc2818912",
        "storage_key": "property/6767906449167444/019d78f6-51eb-7209-99f9-64bcc2818912.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax in the outdoor seating area, complete with Adirondack chairs and a charming mural on the building's exterior.",
      "link": "",
      "alt_text": "Outdoor seating area with Adirondack chairs and a mural on the side of a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_861b8f5f-a372-4263-9b78-855100ba5057",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-51e1-73fd-bb18-7996413a459f.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with a green tunnel and bench, surrounded by a chain-link fence and apartment buildings.",
        "public_id": "019d78f6-51e1-73fd-bb18-7996413a459f",
        "storage_key": "property/6767906449167444/019d78f6-51e1-73fd-bb18-7996413a459f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our pet-friendly community with a dedicated outdoor dog park, featuring play equipment for your furry friends.",
      "link": "",
      "alt_text": "Outdoor dog park with a green tunnel and bench, surrounded by a chain-link fence and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_664c132e-1c19-4d84-b811-d349dbae5ef0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-4ff6-759f-9496-251ba793ae6b.webp",
      "image_media": {
        "alt_text": "Novo Sweetwater monument sign at the entrance of the property.",
        "public_id": "019d78f6-4ff6-759f-9496-251ba793ae6b",
        "storage_key": "property/6767906449167444/019d78f6-4ff6-759f-9496-251ba793ae6b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Novo Sweetwater, where modern living meets natural beauty. This image features the elegant monument sign at the property entrance.",
      "link": "",
      "alt_text": "Novo Sweetwater monument sign at the entrance of the property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9cffe15c-2100-4592-9c00-eb06695ab2bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-4ff6-759f-9496-22579ab192bb.webp",
      "image_media": {
        "alt_text": "Open garage bay with hose and lush trees in the background.",
        "public_id": "019d78f6-4ff6-759f-9496-22579ab192bb",
        "storage_key": "property/6767906449167444/019d78f6-4ff6-759f-9496-22579ab192bb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Convenient garage parking available at our community, complete with a hose for easy cleaning.",
      "link": "",
      "alt_text": "Open garage bay with hose and lush trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11de0551-12a6-4b39-bfd9-7bb8c41c556c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-4d6c-73af-813d-9eae7a3ab356.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and parking lot.",
        "public_id": "019d78f6-4d6c-73af-813d-9eae7a3ab356",
        "storage_key": "property/6767906449167444/019d78f6-4d6c-73af-813d-9eae7a3ab356.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building featuring multiple stories, balconies, and a paved parking area. The building has a contemporary design with mixed-color siding and large windows.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b82a4b5-7881-43d2-9a60-ef8c0f053afd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-4f38-70b9-b020-d52c01f2c253.webp",
      "image_media": {
        "alt_text": "Row of garages with white doors and a red fire extinguisher box mounted on the wall.",
        "public_id": "019d78f6-4f38-70b9-b020-d52c01f2c253",
        "storage_key": "property/6767906449167444/019d78f6-4f38-70b9-b020-d52c01f2c253.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Secure your vehicle in our convenient garage parking. Available for residents, these spaces offer protection from the elements and added peace of mind.",
      "link": "",
      "alt_text": "Row of garages with white doors and a red fire extinguisher box mounted on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_76c3649c-59b0-4e11-93fc-08a988305f13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-4dbd-73e5-9ed7-1fc52d7d73fb.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with dark gray and white siding and balconies.",
        "public_id": "019d78f6-4dbd-73e5-9ed7-1fc52d7d73fb",
        "storage_key": "property/6767906449167444/019d78f6-4dbd-73e5-9ed7-1fc52d7d73fb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Discover comfortable living in this beautifully designed apartment building, featuring spacious balconies and a striking modern exterior.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with dark gray and white siding and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a8d409e-99b4-445e-ba10-e952b6da25cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-4eef-7628-9f3f-5ef2495b68ab.webp",
      "image_media": {
        "alt_text": "Row of six white garage doors on a white building with a dark roof.",
        "public_id": "019d78f6-4eef-7628-9f3f-5ef2495b68ab",
        "storage_key": "property/6767906449167444/019d78f6-4eef-7628-9f3f-5ef2495b68ab.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Six-car garage building with white doors and vinyl siding.",
      "link": "",
      "alt_text": "Row of six white garage doors on a white building with a dark roof.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4cb36f03-f2ac-4b6d-8aaa-c9228b5e6b36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-15ce-711d-a5cf-7cfa9ede9ad3.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and carpeted floor.",
        "public_id": "019d78f6-15ce-711d-a5cf-7cfa9ede9ad3",
        "storage_key": "property/6767906449167444/019d78f6-15ce-711d-a5cf-7cfa9ede9ad3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving for all your storage needs. Perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and carpeted floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e69c51a0-a728-453d-9607-6a1d3f834d54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-10b2-72c9-b663-2d61a2a8e54e.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet and ceiling fan.",
        "public_id": "019d78f6-10b2-72c9-b663-2d61a2a8e54e",
        "storage_key": "property/6767906449167444/019d78f6-10b2-72c9-b663-2d61a2a8e54e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral carpeting and a ceiling fan, ready for your personal touch.",
      "link": "",
      "alt_text": "Bedroom with carpet and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9e4efe1d-8cf8-4e57-ae26-59999659a6c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-1015-7237-920c-8fee4ca93d7a.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet and ceiling fan.",
        "public_id": "019d78f6-1015-7237-920c-8fee4ca93d7a",
        "storage_key": "property/6767906449167444/019d78f6-1015-7237-920c-8fee4ca93d7a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a ceiling fan, and a view into the bathroom.",
      "link": "",
      "alt_text": "Bedroom with carpet and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_baf104d3-4c60-4eed-9c13-5a18d6252d40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-163c-7263-9c06-ed1e96397bda.webp",
      "image_media": {
        "alt_text": "Spacious living area with a ceiling fan and large windows offering views of the exterior buildings.",
        "public_id": "019d78f6-163c-7263-9c06-ed1e96397bda",
        "storage_key": "property/6767906449167444/019d78f6-163c-7263-9c06-ed1e96397bda.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring a modern ceiling fan, large windows with blinds, and elegant wood-look flooring. This room provides access to the outdoors and opens to another area of the apartment.",
      "link": "",
      "alt_text": "Spacious living area with a ceiling fan and large windows offering views of the exterior buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c6bb6b7-6af8-4164-acef-47630f2a04db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-1460-74f8-bf9c-03e30f3c3254.webp",
      "image_media": {
        "alt_text": "Modern walk-in shower with marble tile and glass door.",
        "public_id": "019d78f6-1460-74f8-bf9c-03e30f3c3254",
        "storage_key": "property/6767906449167444/019d78f6-1460-74f8-bf9c-03e30f3c3254.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into luxury with this stunning walk-in shower featuring elegant marble tile and a sleek glass enclosure. A perfect addition to any modern apartment.",
      "link": "",
      "alt_text": "Modern walk-in shower with marble tile and glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a1d93e1-67b0-4c72-b173-8078d5bb7eea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-09bf-7349-8f60-8ba0c638fe13.webp",
      "image_media": {
        "alt_text": "Empty room with neutral carpet and white walls, showing a ceiling fan and two doors.",
        "public_id": "019d78f6-09bf-7349-8f60-8ba0c638fe13",
        "storage_key": "property/6767906449167444/019d78f6-09bf-7349-8f60-8ba0c638fe13.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This empty room features neutral carpeting, clean white walls, and a ceiling fan. It includes two doors, one slightly ajar, leading to other areas of the apartment.",
      "link": "",
      "alt_text": "Empty room with neutral carpet and white walls, showing a ceiling fan and two doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ec7387f-3c8c-4eaa-bf57-668a3d6df497",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-08ef-738c-a387-4a416ad11a72.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a center island.",
        "public_id": "019d78f6-08ef-738c-a387-4a416ad11a72",
        "storage_key": "property/6767906449167444/019d78f6-08ef-738c-a387-4a416ad11a72.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious and contemporary kitchen featuring sleek white cabinetry, a subway tile backsplash, stainless steel appliances, and a large center island perfect for meal prep or casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a center island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_935d9ac6-eebd-4cee-9ad8-f03525a4703f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-0622-7109-9999-a384a89368ad.webp",
      "image_media": {
        "alt_text": "Ground floor patio entrance with gray siding and a white door.",
        "public_id": "019d78f6-0622-7109-9999-a384a89368ad",
        "storage_key": "property/6767906449167444/019d78f6-0622-7109-9999-a384a89368ad.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your own private patio space, perfect for relaxing outdoors.",
      "link": "",
      "alt_text": "Ground floor patio entrance with gray siding and a white door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1760220e-ded5-4030-9593-b1ec788e8cc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-0b98-74eb-afdb-24e59129cb5c.webp",
      "image_media": {
        "alt_text": "Empty bedroom with two windows and a ceiling fan.",
        "public_id": "019d78f6-0b98-74eb-afdb-24e59129cb5c",
        "storage_key": "property/6767906449167444/019d78f6-0b98-74eb-afdb-24e59129cb5c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and bright bedroom with plush carpeting, large windows, and a modern ceiling fan. Ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with two windows and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f791f178-562b-4ee5-82a5-67304fec93bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-06f8-706a-8dc3-6374f9fd3ecb.webp",
      "image_media": {
        "alt_text": "Bedroom with two windows, a closet, and a ceiling fan.",
        "public_id": "019d78f6-06f8-706a-8dc3-6374f9fd3ecb",
        "storage_key": "property/6767906449167444/019d78f6-06f8-706a-8dc3-6374f9fd3ecb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A bright and airy bedroom featuring two large windows, a spacious closet, and a modern ceiling fan for comfort.",
      "link": "",
      "alt_text": "Bedroom with two windows, a closet, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd6a448e-41ce-41ed-8161-0805cd9fdf16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f6-069f-7258-8201-b7bc2671cc25.webp",
      "image_media": {
        "alt_text": "Exterior view of a building entrance with a door and window, surrounded by landscaping.",
        "public_id": "019d78f6-069f-7258-8201-b7bc2671cc25",
        "storage_key": "property/6767906449167444/019d78f6-069f-7258-8201-b7bc2671cc25.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Showcases the exterior of the building, highlighting the architectural details and landscaping.",
      "link": "",
      "alt_text": "Exterior view of a building entrance with a door and window, surrounded by landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3bbc867b-abea-4613-b2f4-b9430c7549dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-fe9b-779d-b453-88dbc13bb4a4.webp",
      "image_media": {
        "alt_text": "Empty room with plush carpet, neutral walls, ceiling fan, and two windows with blinds.",
        "public_id": "019d78f5-fe9b-779d-b453-88dbc13bb4a4",
        "storage_key": "property/6767906449167444/019d78f5-fe9b-779d-b453-88dbc13bb4a4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and bright empty room featuring plush carpeting, neutral toned walls, a modern ceiling fan, and large windows that allow ample natural light to fill the space.",
      "link": "",
      "alt_text": "Empty room with plush carpet, neutral walls, ceiling fan, and two windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c09928b-6ac7-4237-933b-59a9c6d9926c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-ff95-7279-810e-263b14fdda22.webp",
      "image_media": {
        "alt_text": "Spacious empty living room with a ceiling fan, wood-look flooring, and a door to a patio.",
        "public_id": "019d78f5-ff95-7279-810e-263b14fdda22",
        "storage_key": "property/6767906449167444/019d78f5-ff95-7279-810e-263b14fdda22.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious, open-concept living area, perfect for relaxation and entertaining. Features modern finishes and abundant natural light.",
      "link": "",
      "alt_text": "Spacious empty living room with a ceiling fan, wood-look flooring, and a door to a patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3bf8a2c9-67d6-4f8c-8e42-706a4dd43409",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-ffe5-757c-af72-a4a56a2d07b9.webp",
      "image_media": {
        "alt_text": "Open-concept living space with a modern kitchen featuring white cabinetry and stainless steel appliances.",
        "public_id": "019d78f5-ffe5-757c-af72-a4a56a2d07b9",
        "storage_key": "property/6767906449167444/019d78f5-ffe5-757c-af72-a4a56a2d07b9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience the spacious and modern design of our apartment interiors, featuring an open-concept layout that seamlessly connects living and kitchen areas.",
      "link": "",
      "alt_text": "Open-concept living space with a modern kitchen featuring white cabinetry and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2bfff0b6-6fda-4dcb-bcb2-42a15a674bc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-f49d-70a1-97f1-ed8d93bc0af3.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet and a ceiling fan, leading to a bathroom.",
        "public_id": "019d78f5-f49d-70a1-97f1-ed8d93bc0af3",
        "storage_key": "property/6767906449167444/019d78f5-f49d-70a1-97f1-ed8d93bc0af3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting and a modern ceiling fan. Adjacent bathroom features a vanity with ample counter space and storage.",
      "link": "",
      "alt_text": "Empty bedroom with neutral carpet and a ceiling fan, leading to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_17574c2d-4b30-4e05-aa01-dd18084d1ca4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-f43b-7751-9cdc-6d6ac28f0e2b.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet and two windows",
        "public_id": "019d78f5-f43b-7751-9cdc-6d6ac28f0e2b",
        "storage_key": "property/6767906449167444/019d78f5-f43b-7751-9cdc-6d6ac28f0e2b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious empty bedroom with neutral carpet and large windows offering a view of the trees.",
      "link": "",
      "alt_text": "Empty bedroom with carpet and two windows",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_244bf803-9454-435a-8ac7-c06c4dbd1519",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-f0ad-753c-b2a3-aa0fb7666cf4.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with granite countertop, sink, large mirror, and toilet.",
        "public_id": "019d78f5-f0ad-753c-b2a3-aa0fb7666cf4",
        "storage_key": "property/6767906449167444/019d78f5-f0ad-753c-b2a3-aa0fb7666cf4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a spacious vanity with ample storage, a granite countertop, and a large mirror. This apartment bathroom combines functionality and modern design.",
      "link": "",
      "alt_text": "Modern bathroom vanity with granite countertop, sink, large mirror, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_37261e66-c4c4-45fe-8714-fdd4ba0ef61d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-f047-7138-8050-1442645d390a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with granite countertops.",
        "public_id": "019d78f5-f047-7138-8050-1442645d390a",
        "storage_key": "property/6767906449167444/019d78f5-f047-7138-8050-1442645d390a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a bathtub with marble tile surround, a toilet, and a sleek vanity with granite countertops and ample storage space.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7ee9e464-6b10-453d-8a6a-6a77a5c188a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-eef5-779e-b01d-2b4c75a400da.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and large closet, viewed from hallway.",
        "public_id": "019d78f5-eef5-779e-b01d-2b4c75a400da",
        "storage_key": "property/6767906449167444/019d78f5-eef5-779e-b01d-2b4c75a400da.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and a large walk-in closet with shelving, offering ample storage.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and large closet, viewed from hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_18714700-dfdd-41c9-9c4e-5ee7d15b585a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-f046-7618-8a99-d6ab28f680c5.webp",
      "image_media": {
        "alt_text": "Modern bathroom with glass-enclosed shower and toilet.",
        "public_id": "019d78f5-f046-7618-8a99-d6ab28f680c5",
        "storage_key": "property/6767906449167444/019d78f5-f046-7618-8a99-d6ab28f680c5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a spacious, glass-enclosed shower with marble-look tile and a sleek toilet.",
      "link": "",
      "alt_text": "Modern bathroom with glass-enclosed shower and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce4a1e99-b827-4ac0-86c3-4effc2f698dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-eee9-7733-9323-f10d34169ddd.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with storage shelf.",
        "public_id": "019d78f5-eee9-7733-9323-f10d34169ddd",
        "storage_key": "property/6767906449167444/019d78f5-eee9-7733-9323-f10d34169ddd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for easy laundry days. Includes a shelf for extra storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer with storage shelf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_824ebc41-cf2e-4943-8953-098a9c88754c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-efa3-701c-824e-959c5b68c60f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
        "public_id": "019d78f5-efa3-701c-824e-959c5b68c60f",
        "storage_key": "property/6767906449167444/019d78f5-efa3-701c-824e-959c5b68c60f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a central island perfect for meal prep or casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eccfe922-84a2-466e-a2d6-88516c863225",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-eeab-723f-9219-96dee36ab5ed.webp",
      "image_media": {
        "alt_text": "Open concept living area with a modern kitchen featuring stainless steel appliances and an island.",
        "public_id": "019d78f5-eeab-723f-9219-96dee36ab5ed",
        "storage_key": "property/6767906449167444/019d78f5-eeab-723f-9219-96dee36ab5ed.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area seamlessly connected to a modern kitchen, perfect for entertaining and everyday living. Features stainless steel appliances and a central island.",
      "link": "",
      "alt_text": "Open concept living area with a modern kitchen featuring stainless steel appliances and an island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f115f733-be9c-464b-adeb-6bc7035793e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-ef87-719f-94a2-db5cd5744666.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island.",
        "public_id": "019d78f5-ef87-719f-94a2-db5cd5744666",
        "storage_key": "property/6767906449167444/019d78f5-ef87-719f-94a2-db5cd5744666.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience convenient living in this spacious apartment kitchen featuring sleek white cabinetry, stainless steel appliances, and a large central island perfect for meal prep or casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_374b3bc6-fdcb-4520-997b-b8c575f91a6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-c85d-7244-8414-08e35d9ec2ea.webp",
      "image_media": {
        "alt_text": "Balcony with wooden floor and metal railing, overlooking buildings.",
        "public_id": "019d78f5-c85d-7244-8414-08e35d9ec2ea",
        "storage_key": "property/6767906449167444/019d78f5-c85d-7244-8414-08e35d9ec2ea.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on the private balcony, featuring a wooden deck and scenic views.",
      "link": "",
      "alt_text": "Balcony with wooden floor and metal railing, overlooking buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b8b908f-6115-4f6f-b4f5-d1a1ebc53882",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-c75a-776e-9ef2-310515153744.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with stainless steel appliances and a ceiling fan.",
        "public_id": "019d78f5-c75a-776e-9ef2-310515153744",
        "storage_key": "property/6767906449167444/019d78f5-c75a-776e-9ef2-310515153744.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and kitchen area, perfect for entertaining. Features modern stainless steel appliances and a convenient island.",
      "link": "",
      "alt_text": "Open concept living and kitchen area with stainless steel appliances and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da2d13bb-48d8-47db-8e58-25b4183b3c05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-c73c-74ae-937f-f7a529af2474.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, granite countertop, and glass-enclosed shower.",
        "public_id": "019d78f5-c73c-74ae-937f-f7a529af2474",
        "storage_key": "property/6767906449167444/019d78f5-c73c-74ae-937f-f7a529af2474.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into luxury with this stunning apartment bathroom, featuring a sleek vanity, granite countertops, and a spacious glass-enclosed shower.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, granite countertop, and glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b1c90e2-0a2c-4b8b-9602-71850ee6b191",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-c2ee-734d-a605-bc49454578a4.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and two windows.",
        "public_id": "019d78f5-c2ee-734d-a605-bc49454578a4",
        "storage_key": "property/6767906449167444/019d78f5-c2ee-734d-a605-bc49454578a4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This empty bedroom features a ceiling fan and two large windows providing ample natural light. Perfect for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and two windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9c94362-9b51-4e85-b173-64198bd63cd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-c40f-73a9-9d06-0b9923b69119.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a marble-tiled shower and a white bathtub.",
        "public_id": "019d78f5-c40f-73a9-9d06-0b9923b69119",
        "storage_key": "property/6767906449167444/019d78f5-c40f-73a9-9d06-0b9923b69119.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax and unwind in the spacious bathtub, surrounded by elegant marble-inspired tile work. A perfect retreat after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a marble-tiled shower and a white bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_116cd627-bd7f-49df-b324-e52a4cad9862",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-c6af-703e-b1a7-0ca40118c1a1.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and two windows.",
        "public_id": "019d78f5-c6af-703e-b1a7-0ca40118c1a1",
        "storage_key": "property/6767906449167444/019d78f5-c6af-703e-b1a7-0ca40118c1a1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and bright bedroom featuring a ceiling fan and plush carpeting, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and two windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_957345c1-df3a-478a-b4cc-9ef0e0184674",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-c283-763a-a450-7dd9a7b75e18.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet, ceiling fan, and open closet.",
        "public_id": "019d78f5-c283-763a-a450-7dd9a7b75e18",
        "storage_key": "property/6767906449167444/019d78f5-c283-763a-a450-7dd9a7b75e18.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring soft carpeting, a modern ceiling fan, and a walk-in closet for ample storage.",
      "link": "",
      "alt_text": "Bedroom with carpet, ceiling fan, and open closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_73884718-929e-4f06-a0f9-2ee1a9038840",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-c604-7483-86f1-390bbf6b55f8.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and an open closet.",
        "public_id": "019d78f5-c604-7483-86f1-390bbf6b55f8",
        "storage_key": "property/6767906449167444/019d78f5-c604-7483-86f1-390bbf6b55f8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a modern ceiling fan and a walk-in closet with ample shelving.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan and an open closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d3fb8fa-d91e-4cab-ab34-6e8fd6bf5aed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-af95-74fd-9a96-cb7f1b59421f.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with an island and balcony access.",
        "public_id": "019d78f5-af95-74fd-9a96-cb7f1b59421f",
        "storage_key": "property/6767906449167444/019d78f5-af95-74fd-9a96-cb7f1b59421f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious apartment featuring a contemporary kitchen with stainless steel appliances and a central island, flowing into a bright living area with balcony access.",
      "link": "",
      "alt_text": "Modern kitchen and living area with an island and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21bad2de-c1cf-4ab7-9747-db897c38a5be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-b08f-75cd-ac32-8afc5429c961.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with granite countertop and stainless steel fixtures, adjacent to a walk-in closet and shower.",
        "public_id": "019d78f5-b08f-75cd-ac32-8afc5429c961",
        "storage_key": "property/6767906449167444/019d78f5-b08f-75cd-ac32-8afc5429c961.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a dual-sink vanity, granite countertops, and ample storage, including a walk-in closet and walk-in shower.",
      "link": "",
      "alt_text": "Modern bathroom vanity with granite countertop and stainless steel fixtures, adjacent to a walk-in closet and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_486e3655-b16b-4c1d-a3c5-630f6e582a25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-b21d-726e-beca-4aae84fa3a64.webp",
      "image_media": {
        "alt_text": "Modern bathroom with walk-in shower, vanity with granite countertop, and closet.",
        "public_id": "019d78f5-b21d-726e-beca-4aae84fa3a64",
        "storage_key": "property/6767906449167444/019d78f5-b21d-726e-beca-4aae84fa3a64.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a spacious walk-in shower with marble tile, a modern vanity with a granite countertop, and ample closet space for storage.",
      "link": "",
      "alt_text": "Modern bathroom with walk-in shower, vanity with granite countertop, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a2af8887-a2e3-4edb-9b2c-a4dd167a3808",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-b47c-7099-9b8d-20ec256a8c95.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "019d78f5-b47c-7099-9b8d-20ec256a8c95",
        "storage_key": "property/6767906449167444/019d78f5-b47c-7099-9b8d-20ec256a8c95.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience gourmet cooking in this stunning kitchen, complete with sleek white cabinetry, premium stainless steel appliances, and a spacious island perfect for meal prep and casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd9fe44e-8645-4b19-8162-a283cfa8b820",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-af1a-7087-ac3d-6503d91b740d.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and window, view of bathroom",
        "public_id": "019d78f5-af1a-7087-ac3d-6503d91b740d",
        "storage_key": "property/6767906449167444/019d78f5-af1a-7087-ac3d-6503d91b740d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, large window, and plush carpeting. An adjoining bathroom with a vanity and toilet is visible through the doorway.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and window, view of bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_edaabef7-27d6-4e3f-a4bf-eecde25b14cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-b1bd-70a6-bb49-d6c773b32d1e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop, white vanity, toilet, and walk-in shower.",
        "public_id": "019d78f5-b1bd-70a6-bb49-d6c773b32d1e",
        "storage_key": "property/6767906449167444/019d78f5-b1bd-70a6-bb49-d6c773b32d1e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this elegant bathroom featuring a spacious vanity with a granite countertop, a modern toilet, and a sleek walk-in shower with marble-style tiling. Includes a large closet for storage.",
      "link": "",
      "alt_text": "Modern bathroom with a granite countertop, white vanity, toilet, and walk-in shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f1f9994-95a5-42b2-9d73-b596a97fdcd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-b088-72ae-ad7c-30e894291289.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower with marble tile and a nearby walk-in closet.",
        "public_id": "019d78f5-b088-72ae-ad7c-30e894291289",
        "storage_key": "property/6767906449167444/019d78f5-b088-72ae-ad7c-30e894291289.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into luxury with this beautifully designed bathroom, featuring a spacious walk-in shower with elegant marble tile. Adjacent to the bathroom is a convenient walk-in closet, providing ample storage space.",
      "link": "",
      "alt_text": "Modern bathroom with a walk-in shower with marble tile and a nearby walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad2d9184-427b-42b0-afb8-1d09d026aab9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-b04b-73bd-8e26-3c7d8e9bc59c.webp",
      "image_media": {
        "alt_text": "Living room with ceiling fan and balcony access",
        "public_id": "019d78f5-b04b-73bd-8e26-3c7d8e9bc59c",
        "storage_key": "property/6767906449167444/019d78f5-b04b-73bd-8e26-3c7d8e9bc59c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a ceiling fan and access to a private balcony, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with ceiling fan and balcony access",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_adddadd4-fe11-4ca9-acca-1928c358a56c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-aede-7103-9aa3-95c67cc9cefd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island.",
        "public_id": "019d78f5-aede-7103-9aa3-95c67cc9cefd",
        "storage_key": "property/6767906449167444/019d78f5-aede-7103-9aa3-95c67cc9cefd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this stunning kitchen, featuring sleek stainless steel appliances, ample white cabinetry, and a spacious island perfect for meal prep or casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7fe1efb5-e84c-474f-b433-5f02fa54001d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-af34-72d6-b20f-b86b4b57debc.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet",
        "public_id": "019d78f5-af34-72d6-b20f-b86b4b57debc",
        "storage_key": "property/6767906449167444/019d78f5-af34-72d6-b20f-b86b4b57debc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience. Laundry day is a breeze with these modern appliances.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7058465-c637-4d98-b81c-bc1e378e1852",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-8f68-7014-b363-570cdb367bc3.webp",
      "image_media": {
        "alt_text": "Stylish living room with blue sofa, tan accent chair, and entertainment center.",
        "public_id": "019d78f5-8f68-7014-b363-570cdb367bc3",
        "storage_key": "property/6767906449167444/019d78f5-8f68-7014-b363-570cdb367bc3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully appointed apartment featuring a spacious living area with comfortable seating, a sleek entertainment center, and elegant decor.",
      "link": "",
      "alt_text": "Stylish living room with blue sofa, tan accent chair, and entertainment center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_531c7d85-6082-46a1-ba5b-57d7f4565db2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-8f6a-716d-8aca-1165d84087aa.webp",
      "image_media": {
        "alt_text": "Interior of a bedroom with a queen-size bed, a closet, and modern artwork.",
        "public_id": "019d78f5-8f6a-716d-8aca-1165d84087aa",
        "storage_key": "property/6767906449167444/019d78f5-8f6a-716d-8aca-1165d84087aa.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen-size bed, ample closet space, and contemporary art to elevate your living experience.",
      "link": "",
      "alt_text": "Interior of a bedroom with a queen-size bed, a closet, and modern artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f614107d-253b-447c-bce5-336ff8af9ec2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7d67-7179-b22a-d7b650adf134.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-sized bed, blue accent wall with abstract art, and a comfortable reading chair.",
        "public_id": "019d78f5-7d67-7179-b22a-d7b650adf134",
        "storage_key": "property/6767906449167444/019d78f5-7d67-7179-b22a-d7b650adf134.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-sized bed, a serene blue accent wall adorned with modern art, and a cozy reading nook by the window.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-sized bed, blue accent wall with abstract art, and a comfortable reading chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62a27f14-3618-48fe-9bdf-d504417c11d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-81b3-740d-a7bd-9495dce1ec3b.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of a modern apartment with a blue sofa, accent chair, and stainless steel appliances.",
        "public_id": "019d78f5-81b3-740d-a7bd-9495dce1ec3b",
        "storage_key": "property/6767906449167444/019d78f5-81b3-740d-a7bd-9495dce1ec3b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living area with a comfortable blue sofa and elegant accent chair, seamlessly flowing into a well-equipped kitchen with modern appliances. Perfect for contemporary living.",
      "link": "",
      "alt_text": "Living room and kitchen area of a modern apartment with a blue sofa, accent chair, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7a5dd13-3f1a-4721-9db8-3753167873ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7d0b-7267-b494-020c26b2d022.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, granite countertops, and a toilet.",
        "public_id": "019d78f5-7d0b-7267-b494-020c26b2d022",
        "storage_key": "property/6767906449167444/019d78f5-7d0b-7267-b494-020c26b2d022.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish and modern bathroom featuring a double vanity with granite countertops, a large mirror, and a comfortable toilet. The space is enhanced with decorative elements and plush towels.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, granite countertops, and a toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_80ec4e13-d1e7-472a-8f59-b1e7efa75c6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7b38-777f-b6bc-6b89d064e12c.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, tan accent chair, coffee table, and desk.",
        "public_id": "019d78f5-7b38-777f-b6bc-6b89d064e12c",
        "storage_key": "property/6767906449167444/019d78f5-7b38-777f-b6bc-6b89d064e12c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable blue sofa, a chic tan accent chair, and a functional desk space, perfect for relaxation and productivity.",
      "link": "",
      "alt_text": "Living room with blue sofa, tan accent chair, coffee table, and desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c327bf67-3beb-4b95-b156-1b44fd0c03b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7b3b-70aa-ace5-ac5e48138777.webp",
      "image_media": {
        "alt_text": "Modern living room with blue couch, accent chair, and open kitchen.",
        "public_id": "019d78f5-7b3b-70aa-ace5-ac5e48138777",
        "storage_key": "property/6767906449167444/019d78f5-7b3b-70aa-ace5-ac5e48138777.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable blue sofa, stylish accent chair, and an open-concept kitchen with white cabinetry and stainless steel appliances.",
      "link": "",
      "alt_text": "Modern living room with blue couch, accent chair, and open kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0b96db8-b18c-4bc1-a279-1d3bb31a22e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7bf3-739f-bff0-4e1637498ad1.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room with shelving above.",
        "public_id": "019d78f5-7bf3-739f-bff0-4e1637498ad1",
        "storage_key": "property/6767906449167444/019d78f5-7bf3-739f-bff0-4e1637498ad1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry room with shelving above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b29f955f-aa2b-4202-8d84-6ed4daf7e5ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7c5d-75cd-99dc-98117ee5a09c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island with seating.",
        "public_id": "019d78f5-7c5d-75cd-99dc-98117ee5a09c",
        "storage_key": "property/6767906449167444/019d78f5-7c5d-75cd-99dc-98117ee5a09c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this spacious and modern kitchen, featuring sleek white cabinetry, granite countertops, and a convenient island.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_55313cee-3ac7-42a0-8ee1-53dac40d540d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7b22-76a9-9ad2-2d79a41da2d6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island seating and open living area.",
        "public_id": "019d78f5-7b22-76a9-9ad2-2d79a41da2d6",
        "storage_key": "property/6767906449167444/019d78f5-7b22-76a9-9ad2-2d79a41da2d6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen with island seating and an adjacent living area. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with island seating and open living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_800a5f14-e71e-46a7-b21a-553758b43013",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7b31-7038-b9ab-daf5cf26053b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
        "public_id": "019d78f5-7b31-7038-b9ab-daf5cf26053b",
        "storage_key": "property/6767906449167444/019d78f5-7b31-7038-b9ab-daf5cf26053b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and a central island perfect for dining and prep.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99c5753b-7b80-4cb3-98b5-d15623346270",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-7a42-779a-9946-6ce0231b00b6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "019d78f5-7a42-779a-9946-6ce0231b00b6",
        "storage_key": "property/6767906449167444/019d78f5-7a42-779a-9946-6ce0231b00b6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring sleek white cabinetry, high-end stainless steel appliances, a granite countertop island with seating, and elegant bar stools.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c3be744-8a5f-42ec-b214-0dc08ccb4614",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-5dd2-74a8-9ca1-3d3fa2b42b46.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet and a ceiling fan.",
        "public_id": "019d78f5-5dd2-74a8-9ca1-3d3fa2b42b46",
        "storage_key": "property/6767906449167444/019d78f5-5dd2-74a8-9ca1-3d3fa2b42b46.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious empty bedroom featuring plush neutral carpeting, a modern ceiling fan, and a closed door. Perfect for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with neutral carpet and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94961423-1784-4e49-a46b-5be36589ff87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4fab-73af-8688-b3d156e3f3eb.webp",
      "image_media": {
        "alt_text": "Empty room with hardwood floors, ceiling fan, window, and balcony door.",
        "public_id": "019d78f5-4fab-73af-8688-b3d156e3f3eb",
        "storage_key": "property/6767906449167444/019d78f5-4fab-73af-8688-b3d156e3f3eb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and bright empty room featuring elegant hardwood floors, a modern ceiling fan, and a large window with a glass door leading to a private balcony. Perfect for a living space.",
      "link": "",
      "alt_text": "Empty room with hardwood floors, ceiling fan, window, and balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d4e23efe-1241-42cc-8aab-42a04357cd3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4cf6-752a-85ff-7529c9426fd8.webp",
      "image_media": {
        "alt_text": "Empty bedroom with two windows and a ceiling fan.",
        "public_id": "019d78f5-4cf6-752a-85ff-7529c9426fd8",
        "storage_key": "property/6767906449167444/019d78f5-4cf6-752a-85ff-7529c9426fd8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a modern ceiling fan, and ample natural light filtering through two large windows.",
      "link": "",
      "alt_text": "Empty bedroom with two windows and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b7040fd-6e0e-49af-84fb-ba9136f96a36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4d56-7228-a785-b56aaee3ff2a.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area in an apartment with stainless steel appliances and island.",
        "public_id": "019d78f5-4d56-7228-a785-b56aaee3ff2a",
        "storage_key": "property/6767906449167444/019d78f5-4d56-7228-a785-b56aaee3ff2a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring a fully equipped kitchen with stainless steel appliances and a central island, flowing into an open living area.",
      "link": "",
      "alt_text": "Modern kitchen and living area in an apartment with stainless steel appliances and island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_423fd1b4-d2e9-4533-a40f-0eb1a7886bee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4fc6-73dc-b804-261503db7ee9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019d78f5-4fc6-73dc-b804-261503db7ee9",
        "storage_key": "property/6767906449167444/019d78f5-4fc6-73dc-b804-261503db7ee9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet storage, and a central island.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b0c9b538-51ee-49cd-9964-1b255da99e3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4c98-7795-9cf8-41258bf865a3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop, white vanity, toilet, and a large mirror reflecting a tiled shower.",
        "public_id": "019d78f5-4c98-7795-9cf8-41258bf865a3",
        "storage_key": "property/6767906449167444/019d78f5-4c98-7795-9cf8-41258bf865a3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a granite countertop vanity, ample storage, a clean white toilet, and a shower with elegant tilework.",
      "link": "",
      "alt_text": "Modern bathroom with a granite countertop, white vanity, toilet, and a large mirror reflecting a tiled shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39380562-4e32-4cd7-98a9-4825aa0a83ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4b79-7751-bbec-2814bf40ca3b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island.",
        "public_id": "019d78f5-4b79-7751-bbec-2814bf40ca3b",
        "storage_key": "property/6767906449167444/019d78f5-4b79-7751-bbec-2814bf40ca3b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, stainless steel appliances, a subway tile backsplash, and a large island perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3bec9f16-8c63-4b07-be7f-d1684be326e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4ab5-72bb-a595-58a6f01e0f3b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, granite countertops, and a large island.",
        "public_id": "019d78f5-4ab5-72bb-a595-58a6f01e0f3b",
        "storage_key": "property/6767906449167444/019d78f5-4ab5-72bb-a595-58a6f01e0f3b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring ample cabinet space, sleek countertops, and a large island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, granite countertops, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b32499a4-d647-40d4-9684-945c5c8cfe0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4ab7-778f-a7c8-0cbe9ff3eca9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, large island, and granite countertops.",
        "public_id": "019d78f5-4ab7-778f-a7c8-0cbe9ff3eca9",
        "storage_key": "property/6767906449167444/019d78f5-4ab7-778f-a7c8-0cbe9ff3eca9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring white shaker cabinets, a stainless steel refrigerator, a sleek island, and granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, large island, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_901df861-43ec-4a54-b2cd-b72302443cd5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4bdb-701e-96ae-983872693f84.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer unit with a shelf above",
        "public_id": "019d78f5-4bdb-701e-96ae-983872693f84",
        "storage_key": "property/6767906449167444/019d78f5-4bdb-701e-96ae-983872693f84.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, complete with a shelf for all your laundry essentials.",
      "link": "",
      "alt_text": "Stackable washer and dryer unit with a shelf above",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_216f3995-678e-4b18-8171-5b10563798e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-4ad8-76bc-b81e-a9f62a12e0d2.webp",
      "image_media": {
        "alt_text": "Modern bathroom with marble tile shower and white bathtub.",
        "public_id": "019d78f5-4ad8-76bc-b81e-a9f62a12e0d2",
        "storage_key": "property/6767906449167444/019d78f5-4ad8-76bc-b81e-a9f62a12e0d2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy a relaxing soak in this elegant bathroom, featuring a marble-tiled shower and a spacious bathtub, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with marble tile shower and white bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b4a89db-e6bf-4070-9d2e-f61630bf5e0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-0102-751b-aa45-d285937bc75d.webp",
      "image_media": {
        "alt_text": "Outdoor communal area with a fire pit, Adirondack chairs, and string lights.",
        "public_id": "019d78f5-0102-751b-aa45-d285937bc75d",
        "storage_key": "property/6767906449167444/019d78f5-0102-751b-aa45-d285937bc75d.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy evenings around the fire pit in this inviting communal outdoor space, complete with comfortable seating and ambient string lighting.",
      "link": "",
      "alt_text": "Outdoor communal area with a fire pit, Adirondack chairs, and string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b004a69-aa46-4210-9daa-a272667e4e59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-0cb7-759a-85b7-8c84b3fab67a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, granite countertop, toilet, and shower.",
        "public_id": "019d78f5-0cb7-759a-85b7-8c84b3fab67a",
        "storage_key": "property/6767906449167444/019d78f5-0cb7-759a-85b7-8c84b3fab67a.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a spacious vanity with a granite countertop, a modern toilet, and a walk-in shower, perfect for a relaxing start to your day.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, granite countertop, toilet, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a06e95f2-33af-43cf-8ec6-5fdfaa8f63a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-0206-75fc-b1c1-9599f0ef8936.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with comfortable seating and ceiling fans, overlooking a pool area.",
        "public_id": "019d78f5-0206-75fc-b1c1-9599f0ef8936",
        "storage_key": "property/6767906449167444/019d78f5-0206-75fc-b1c1-9599f0ef8936.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious outdoor lounge, featuring plush seating and overhead fans for your comfort, adjacent to our sparkling pool.",
      "link": "",
      "alt_text": "Outdoor lounge area with comfortable seating and ceiling fans, overlooking a pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1177a76a-d103-4d8e-ba56-2f9426d5d74f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-0916-70d5-bdde-90413f5ecb52.webp",
      "image_media": {
        "alt_text": "Six-car garage building with white doors and dark trim, set against a backdrop of lush green trees.",
        "public_id": "019d78f5-0916-70d5-bdde-90413f5ecb52",
        "storage_key": "property/6767906449167444/019d78f5-0916-70d5-bdde-90413f5ecb52.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Secure your vehicle in our convenient multi-car garage. Ample parking space for residents.",
      "link": "",
      "alt_text": "Six-car garage building with white doors and dark trim, set against a backdrop of lush green trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63ca6b55-10cf-496f-a9eb-628c48c53451",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-048f-75cb-bbcc-e9cd5611299c.webp",
      "image_media": {
        "alt_text": "Outdoor patio with fire pit, lounge seating, grills, and covered entertainment area.",
        "public_id": "019d78f5-048f-75cb-bbcc-e9cd5611299c",
        "storage_key": "property/6767906449167444/019d78f5-048f-75cb-bbcc-e9cd5611299c.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy evenings by the fire pit or host a barbecue with friends in our spacious outdoor lounge area, complete with grills and a covered entertainment space.",
      "link": "",
      "alt_text": "Outdoor patio with fire pit, lounge seating, grills, and covered entertainment area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b652e0a7-860b-4c1b-871b-12507567705f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-0166-720c-9c96-22facff4c5f8.webp",
      "image_media": {
        "alt_text": "Novo Blue Ridge apartment building exterior with monument sign and landscaping.",
        "public_id": "019d78f5-0166-720c-9c96-22facff4c5f8",
        "storage_key": "property/6767906449167444/019d78f5-0166-720c-9c96-22facff4c5f8.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Exterior view of the Novo Blue Ridge apartment building, featuring modern architecture, balconies, and a well-maintained landscape with a monument sign and flower beds.",
      "link": "",
      "alt_text": "Novo Blue Ridge apartment building exterior with monument sign and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a9439d52-8e46-4c2d-bc91-2b7a48e41136",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-026c-75c9-bfe5-1ba47fa7c574.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with a covered patio and lawn.",
        "public_id": "019d78f5-026c-75c9-bfe5-1ba47fa7c574",
        "storage_key": "property/6767906449167444/019d78f5-026c-75c9-bfe5-1ba47fa7c574.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring a covered patio area with seating, surrounded by a manicured lawn and trees.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with a covered patio and lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7dd56b71-6031-4cb7-97ec-2e68ec1a95ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-00e9-730a-9a7e-dcfcabf60146.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with a parking lot in front.",
        "public_id": "019d78f5-00e9-730a-9a7e-dcfcabf60146",
        "storage_key": "property/6767906449167444/019d78f5-00e9-730a-9a7e-dcfcabf60146.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing its modern design and the convenient parking available for residents.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with a parking lot in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e9b624dd-6d86-4761-8e41-c4f04ab2ef75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-0308-7388-b6c8-2782bd7f0115.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with hanging chairs, a fire pit, and mountain mural.",
        "public_id": "019d78f5-0308-7388-b6c8-2782bd7f0115",
        "storage_key": "property/6767906449167444/019d78f5-0308-7388-b6c8-2782bd7f0115.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our community lounge area, complete with comfortable hanging chairs, a cozy fire pit, and a vibrant mountain mural. Perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Outdoor lounge area with hanging chairs, a fire pit, and mountain mural.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1b49c91-3ff6-4ed5-9046-071212a2ef5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f5-02b7-71fd-b310-40de9228f9af.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio area with tables, chairs, a grill, and an outdoor television.",
        "public_id": "019d78f5-02b7-71fd-b310-40de9228f9af",
        "storage_key": "property/6767906449167444/019d78f5-02b7-71fd-b310-40de9228f9af.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community's covered patio, complete with comfortable seating, a barbecue grill, and an outdoor TV for entertainment.",
      "link": "",
      "alt_text": "Outdoor covered patio area with tables, chairs, a grill, and an outdoor television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4340890a-8ef9-491b-8950-a6b4dc3ce587",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f3f0-75ac-9f22-c094f3634e7a.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multifamily property's clubhouse building, featuring white siding and large windows.",
        "public_id": "019d78f4-f3f0-75ac-9f22-c094f3634e7a",
        "storage_key": "property/6767906449167444/019d78f4-f3f0-75ac-9f22-c094f3634e7a.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Charming exterior of the clubhouse building, showcasing modern architecture with clean lines, white siding, and expansive windows. The surrounding landscape adds to the welcoming ambiance.",
      "link": "",
      "alt_text": "Exterior view of a modern multifamily property's clubhouse building, featuring white siding and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b41b79cb-1e79-4f7d-aad4-83a6e4cead9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f454-7385-9fd9-2f93ac35b199.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with string lights and fire pit at dusk.",
        "public_id": "019d78f4-f454-7385-9fd9-2f93ac35b199",
        "storage_key": "property/6767906449167444/019d78f4-f454-7385-9fd9-2f93ac35b199.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool or gather with friends around the fire pit. Enjoy the ambiance of string lights in this beautiful community amenity.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area with string lights and fire pit at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b8f7523-ce1c-4316-b326-923378293771",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f355-75ce-badd-ed60eb680096.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019d78f4-f355-75ce-badd-ed60eb680096",
        "storage_key": "property/6767906449167444/019d78f4-f355-75ce-badd-ed60eb680096.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, or relax in a lounge chair. The adjacent patio area features comfortable seating and tables, perfect for socializing or enjoying a meal al fresco. The modern apartment buildings provide a beautiful backdrop to this amenity-rich community.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8ffb98e-32bb-4346-977b-397137eed2e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f5ed-712d-9542-1aecdfa4712a.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and string lights at dusk.",
        "public_id": "019d78f4-f5ed-712d-9542-1aecdfa4712a",
        "storage_key": "property/6767906449167444/019d78f4-f5ed-712d-9542-1aecdfa4712a.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge seating and ambient string lighting. Perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and string lights at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c04348a-53dd-430b-a774-31a4dda78793",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f3e7-773f-b42e-d90f4a352f03.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with covered seating and grills at apartment complex.",
        "public_id": "019d78f4-f3e7-773f-b42e-d90f4a352f03",
        "storage_key": "property/6767906449167444/019d78f4-f3e7-773f-b42e-d90f4a352f03.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, complete with comfortable lounge seating, shaded cabanas, and convenient grilling stations. Your perfect oasis awaits.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area with covered seating and grills at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_193907f1-0694-4008-9edb-39be1e1d3377",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f3cd-735f-b105-18d44afb5610.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with multiple balconies and a parking lot.",
        "public_id": "019d78f4-f3cd-735f-b105-18d44afb5610",
        "storage_key": "property/6767906449167444/019d78f4-f3cd-735f-b105-18d44afb5610.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing its modern architecture and amenities like a parking lot and balconies.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with multiple balconies and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1e9cc28-b371-4eb0-b375-a3a177e42fca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f362-74cd-b24b-f9ff499e968e.webp",
      "image_media": {
        "alt_text": "A modern apartment complex with a large swimming pool and lounge chairs at sunset.",
        "public_id": "019d78f4-f362-74cd-b24b-f9ff499e968e",
        "storage_key": "property/6767906449167444/019d78f4-f362-74cd-b24b-f9ff499e968e.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and spacious lounge area at our community, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "A modern apartment complex with a large swimming pool and lounge chairs at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_68e0dcbc-31ea-47f8-b96e-375a1553d0fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f39c-702f-a3fb-39fab9b037f3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower and vanity, adjacent to a bedroom.",
        "public_id": "019d78f4-f39c-702f-a3fb-39fab9b037f3",
        "storage_key": "property/6767906449167444/019d78f4-f39c-702f-a3fb-39fab9b037f3.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom featuring a spacious walk-in shower and a sleek vanity. This bathroom connects seamlessly to a well-lit bedroom, offering a comfortable and convenient living experience.",
      "link": "",
      "alt_text": "Modern bathroom with a walk-in shower and vanity, adjacent to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d410e30-70a0-4ec3-a64d-884c9b01ac4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f517-7630-905a-78f427a06423.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and a modern apartment building in the background.",
        "public_id": "019d78f4-f517-7630-905a-78f427a06423",
        "storage_key": "property/6767906449167444/019d78f4-f517-7630-905a-78f427a06423.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush greenery.",
      "link": "",
      "alt_text": "Bright blue swimming pool with lounge chairs and a modern apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aecfdc47-47c9-4543-b974-b28c711f2c50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-f337-7118-9b15-b76a9162cca8.webp",
      "image_media": {
        "alt_text": "Living room with sofa, ottoman, armchair, and artwork.",
        "public_id": "019d78f4-f337-7118-9b15-b76a9162cca8",
        "storage_key": "property/6767906449167444/019d78f4-f337-7118-9b15-b76a9162cca8.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, a plush ottoman, and a modern armchair, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, ottoman, armchair, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c323a04c-05cd-4f80-a12e-29a1e185de4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-663c-77aa-997f-5c29d7361f61.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and armchair.",
        "public_id": "019d78f4-663c-77aa-997f-5c29d7361f61",
        "storage_key": "property/6767906449167444/019d78f4-663c-77aa-997f-5c29d7361f61.webp",
        "width": 1481,
        "height": 987
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom featuring a comfortable queen-size bed, elegant nightstands, and a cozy armchair.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad6fc557-db86-475d-a6e9-9afd6e752dd2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-627f-765b-ba97-6abddc04a28c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast island with blue stools.",
        "public_id": "019d78f4-627f-765b-ba97-6abddc04a28c",
        "storage_key": "property/6767906449167444/019d78f4-627f-765b-ba97-6abddc04a28c.webp",
        "width": 1464,
        "height": 976
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish kitchen, featuring ample cabinet space, modern appliances, and a convenient breakfast island.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast island with blue stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa821b18-b398-48f9-a1fc-0b9b34b66a66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-664f-75cb-836f-3b3bf02dfd8e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with blue stools.",
        "public_id": "019d78f4-664f-75cb-836f-3b3bf02dfd8e",
        "storage_key": "property/6767906449167444/019d78f4-664f-75cb-836f-3b3bf02dfd8e.webp",
        "width": 1494,
        "height": 996
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring ample cabinet space, sleek stainless steel appliances, and a large island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with blue stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2ff14cba-de6e-4077-9802-ac8f25b57ea7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-6639-7485-a53d-098038d25a56.webp",
      "image_media": {
        "alt_text": "Modern white building with large windows and a parking lot in front.",
        "public_id": "019d78f4-6639-7485-a53d-098038d25a56",
        "storage_key": "property/6767906449167444/019d78f4-6639-7485-a53d-098038d25a56.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of a modern building, featuring large windows and a prominent entrance, set within a well-maintained parking area.",
      "link": "",
      "alt_text": "Modern white building with large windows and a parking lot in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c77591fc-491a-46e4-a9fb-675217980d0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-663b-71ae-9cd2-5830976f8db2.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with multiple balconies and a parking lot.",
        "public_id": "019d78f4-663b-71ae-9cd2-5830976f8db2",
        "storage_key": "property/6767906449167444/019d78f4-663b-71ae-9cd2-5830976f8db2.webp",
        "width": 1200,
        "height": 674
      },
      "title": "Community",
      "description": "Discover modern apartment living with stunning exterior views, featuring spacious balconies and convenient parking.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with multiple balconies and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63378e52-236c-453c-856d-660686518156",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-61e9-7168-aee5-0388932ef5e9.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, closet, and ensuite bathroom visible.",
        "public_id": "019d78f4-61e9-7168-aee5-0388932ef5e9",
        "storage_key": "property/6767906449167444/019d78f4-61e9-7168-aee5-0388932ef5e9.webp",
        "width": 1495,
        "height": 997
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, ample closet space, and convenient access to the ensuite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, closet, and ensuite bathroom visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_81274761-0f12-4df1-8fdb-23af56f31196",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-5e51-70db-bb9a-9e8b48f4a4bb.webp",
      "image_media": {
        "alt_text": "Row of treadmills and elliptical machines in a well-lit fitness center with large windows.",
        "public_id": "019d78f4-5e51-70db-bb9a-9e8b48f4a4bb",
        "storage_key": "property/6767906449167444/019d78f4-5e51-70db-bb9a-9e8b48f4a4bb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills and elliptical machines, perfect for your daily workout routine.",
      "link": "",
      "alt_text": "Row of treadmills and elliptical machines in a well-lit fitness center with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e061342d-548d-4ce5-9d19-61e6e796c4ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-5ddc-7078-8520-9b008b7f3419.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room area with white cabinets, stainless steel appliances, and blue accent wall.",
        "public_id": "019d78f4-5ddc-7078-8520-9b008b7f3419",
        "storage_key": "property/6767906449167444/019d78f4-5ddc-7078-8520-9b008b7f3419.webp",
        "width": 1494,
        "height": 996
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with ample cabinet space and a comfortable living room, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and living room area with white cabinets, stainless steel appliances, and blue accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f40fb88-3990-469e-8edb-1b7e7828073f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-52ae-7779-bbf2-75764a93bee5.webp",
      "image_media": {
        "alt_text": "Modern open-concept living area with kitchen island, laundry room, and living room.",
        "public_id": "019d78f4-52ae-7779-bbf2-75764a93bee5",
        "storage_key": "property/6767906449167444/019d78f4-52ae-7779-bbf2-75764a93bee5.webp",
        "width": 1494,
        "height": 996
      },
      "title": "Apartment",
      "description": "Step into this stunning open-concept living space, featuring a contemporary kitchen island perfect for entertaining, a convenient in-unit laundry room, and a cozy living room.",
      "link": "",
      "alt_text": "Modern open-concept living area with kitchen island, laundry room, and living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c9252fc-651b-4f81-8bb3-69d536ba493c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-51e4-7307-a2ab-0fd12251349c.webp",
      "image_media": {
        "alt_text": "Row of kettlebells in a gym.",
        "public_id": "019d78f4-51e4-7307-a2ab-0fd12251349c",
        "storage_key": "property/6767906449167444/019d78f4-51e4-7307-a2ab-0fd12251349c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Get your workout in at our fully equipped fitness center, featuring a range of weight training equipment like these kettlebells.",
      "link": "",
      "alt_text": "Row of kettlebells in a gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_daba147e-3bcc-4af3-924b-096fe6a7c909",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-4c62-7608-a9eb-c2a5ec244e19.webp",
      "image_media": {
        "alt_text": "Community dining area with wooden tables and blue chairs.",
        "public_id": "019d78f4-4c62-7608-a9eb-c2a5ec244e19",
        "storage_key": "property/6767906449167444/019d78f4-4c62-7608-a9eb-c2a5ec244e19.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our communal dining spaces, perfect for hosting friends or enjoying a quiet meal.",
      "link": "",
      "alt_text": "Community dining area with wooden tables and blue chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f7b5582-84d9-4e3d-aa5b-bc5457d18a21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-504d-724a-a633-0f647e78e32c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, microwave, and sink.",
        "public_id": "019d78f4-504d-724a-a633-0f647e78e32c",
        "storage_key": "property/6767906449167444/019d78f4-504d-724a-a633-0f647e78e32c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring a large stainless steel refrigerator, ample cabinet space, and a decorative backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel refrigerator, microwave, and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_47e8eeeb-867c-4127-a3c1-fc9dfba12d18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-4f20-7656-a815-9ffff5c0e338.webp",
      "image_media": {
        "alt_text": "Community lounge area with coffee station and seating.",
        "public_id": "019d78f4-4f20-7656-a815-9ffff5c0e338",
        "storage_key": "property/6767906449167444/019d78f4-4f20-7656-a815-9ffff5c0e338.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax in our community lounge, complete with a coffee station and comfortable seating.",
      "link": "",
      "alt_text": "Community lounge area with coffee station and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d820bd06-a9ad-455c-975f-2bb1c5657210",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-4bec-73ad-8f71-90be6c0fc548.webp",
      "image_media": {
        "alt_text": "Indoor gym with cardio equipment including treadmills, rowing machine, and stationary bikes.",
        "public_id": "019d78f4-4bec-73ad-8f71-90be6c0fc548",
        "storage_key": "property/6767906449167444/019d78f4-4bec-73ad-8f71-90be6c0fc548.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, rowing machines, and stationary bikes for your workout needs.",
      "link": "",
      "alt_text": "Indoor gym with cardio equipment including treadmills, rowing machine, and stationary bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63f0d513-57a8-4a69-8976-904491cda417",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-4e2e-746b-87dd-5baedf746fcb.webp",
      "image_media": {
        "alt_text": "Cardio machines including treadmills and stair climber in a well-lit fitness center.",
        "public_id": "019d78f4-4e2e-746b-87dd-5baedf746fcb",
        "storage_key": "property/6767906449167444/019d78f4-4e2e-746b-87dd-5baedf746fcb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a variety of cardio equipment for your workout needs.",
      "link": "",
      "alt_text": "Cardio machines including treadmills and stair climber in a well-lit fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a1a18e59-10b3-4a1b-bf12-780ed1be9a70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-4bf5-74f6-b060-2d8867b69ba9.webp",
      "image_media": {
        "alt_text": "Community lounge area with high-top tables and chairs.",
        "public_id": "019d78f4-4bf5-74f6-b060-2d8867b69ba9",
        "storage_key": "property/6767906449167444/019d78f4-4bf5-74f6-b060-2d8867b69ba9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and socialize in our community lounge, featuring comfortable seating and modern design.",
      "link": "",
      "alt_text": "Community lounge area with high-top tables and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72d57dc6-bbdd-407a-aa58-b985ab52f022",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-381d-74da-b275-ab7877eb291c.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with comfortable seating, dining tables, and a large screen TV.",
        "public_id": "019d78f4-381d-74da-b275-ab7877eb291c",
        "storage_key": "property/6767906449167444/019d78f4-381d-74da-b275-ab7877eb291c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish communal lounge, featuring ample seating, dining areas, and entertainment options.",
      "link": "",
      "alt_text": "Modern communal lounge area with comfortable seating, dining tables, and a large screen TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc01f1ed-f4dc-46cc-8aa2-264e5cae6a4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-3b34-72dd-8140-cbcfc099a17c.webp",
      "image_media": {
        "alt_text": "Community lounge area with a live-edge wood table, comfortable seating, and a modern kitchen backsplash.",
        "public_id": "019d78f4-3b34-72dd-8140-cbcfc099a17c",
        "storage_key": "property/6767906449167444/019d78f4-3b34-72dd-8140-cbcfc099a17c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Gather in the stylish community lounge, featuring a spacious live-edge dining table and a chic accent wall with a convenient kitchenette.",
      "link": "",
      "alt_text": "Community lounge area with a live-edge wood table, comfortable seating, and a modern kitchen backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de9792ac-2a13-4c18-aef2-0bfb609b6ee0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-3a17-7792-9367-0c7d798d9c72.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with seating, a large TV, and a dining area with a refrigerator.",
        "public_id": "019d78f4-3a17-7792-9367-0c7d798d9c72",
        "storage_key": "property/6767906449167444/019d78f4-3a17-7792-9367-0c7d798d9c72.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating, a large television for entertainment, and a convenient dining area with modern appliances.",
      "link": "",
      "alt_text": "Modern community lounge area with seating, a large TV, and a dining area with a refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6403ebfb-b72f-47f8-8cd4-55340a2e836a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-36ee-70bb-a1aa-893ac6571869.webp",
      "image_media": {
        "alt_text": "Communal lounge area with high-top tables and chairs, and a coffee bar with a TV above.",
        "public_id": "019d78f4-36ee-70bb-a1aa-893ac6571869",
        "storage_key": "property/6767906449167444/019d78f4-36ee-70bb-a1aa-893ac6571869.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy relaxing in our beautifully designed communal lounge, complete with comfortable seating and a convenient coffee bar.",
      "link": "",
      "alt_text": "Communal lounge area with high-top tables and chairs, and a coffee bar with a TV above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9407f82a-e352-476b-8c7d-eb4d9f91ea21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-380f-749b-8cd3-8bd1ca564b5f.webp",
      "image_media": {
        "alt_text": "Community lounge with large live-edge dining table, chairs, seating area with TV, and kitchenette.",
        "public_id": "019d78f4-380f-749b-8cd3-8bd1ca564b5f",
        "storage_key": "property/6767906449167444/019d78f4-380f-749b-8cd3-8bd1ca564b5f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our stylish community lounge, featuring a large live-edge dining table, comfortable seating, and a convenient kitchenette.",
      "link": "",
      "alt_text": "Community lounge with large live-edge dining table, chairs, seating area with TV, and kitchenette.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5496d9cc-5e69-48d7-99a1-50d1fa5ba25b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-3a08-7133-bf2c-55f579bfd666.webp",
      "image_media": {
        "alt_text": "Fitness center with weight racks, treadmills, and exercise machines.",
        "public_id": "019d78f4-3a08-7133-bf2c-55f579bfd666",
        "storage_key": "property/6767906449167444/019d78f4-3a08-7133-bf2c-55f579bfd666.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a TRX training zone, weight racks, treadmills, and various exercise machines for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with weight racks, treadmills, and exercise machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62faf0ed-b03b-4211-99ec-e171994e8b83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-3876-701f-9e2a-1d178f4d8ef9.webp",
      "image_media": {
        "alt_text": "Community lounge area with a live edge dining table and seating.",
        "public_id": "019d78f4-3876-701f-9e2a-1d178f4d8ef9",
        "storage_key": "property/6767906449167444/019d78f4-3876-701f-9e2a-1d178f4d8ef9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and socialize in our spacious community lounge, featuring a communal dining table perfect for gatherings.",
      "link": "",
      "alt_text": "Community lounge area with a live edge dining table and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b4da7d4-09e6-467a-899c-3a4bd62460d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-36a0-76bd-8938-886cdaa3a203.webp",
      "image_media": {
        "alt_text": "Modern community lounge with comfortable seating, coffee tables, and a large TV.",
        "public_id": "019d78f4-36a0-76bd-8938-886cdaa3a203",
        "storage_key": "property/6767906449167444/019d78f4-36a0-76bd-8938-886cdaa3a203.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring plush seating, a large flat-screen TV, and a beautifully designed space perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Modern community lounge with comfortable seating, coffee tables, and a large TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_417aa98c-4b16-4667-ad7e-a7849280b638",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-365f-703e-add0-564d66ea6538.webp",
      "image_media": {
        "alt_text": "Gym equipment including slam balls and weight bench.",
        "public_id": "019d78f4-365f-703e-add0-564d66ea6538",
        "storage_key": "property/6767906449167444/019d78f4-365f-703e-add0-564d66ea6538.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of weights and exercise machines for residents.",
      "link": "",
      "alt_text": "Gym equipment including slam balls and weight bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3925021-b54c-4c4a-a7ea-2e9894d1dd3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f4-3620-748a-9873-d8239985de71.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with weight machines, free weights, and cardio equipment.",
        "public_id": "019d78f4-3620-748a-9873-d8239985de71",
        "storage_key": "property/6767906449167444/019d78f4-3620-748a-9873-d8239985de71.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of equipment to suit all your workout needs.",
      "link": "",
      "alt_text": "Fully equipped fitness center with weight machines, free weights, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0bc31b9b-ba93-499d-8675-8db10b3e721c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78f1-8763-71bf-83cc-088f7888f324.webp",
      "image_media": {
        "alt_text": "Two men petting a dog in a modern apartment.",
        "public_id": "019d78f1-8763-71bf-83cc-088f7888f324",
        "storage_key": "property/6767906449167444/019d78f1-8763-71bf-83cc-088f7888f324.webp",
        "width": 3072,
        "height": 1296
      },
      "title": "Lifestyle",
      "description": "Enjoy life's simple pleasures with your furry friends in a comfortable and pet-friendly apartment community.",
      "link": "",
      "alt_text": "Two men petting a dog in a modern apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_edec1609-009f-4463-86b0-accc41ec04fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-f8b8-7428-af6b-895ad185a082.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabanas",
        "public_id": "019d78eb-f8b8-7428-af6b-895ad185a082",
        "storage_key": "property/6767906449167444/019d78eb-f8b8-7428-af6b-895ad185a082.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, featuring comfortable lounge chairs and private cabanas for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabanas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6ee76f01-ad75-4d83-bd80-6bda6e049ed5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78ec-015e-76ad-ad61-25b5622d2f7c.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit with chairs and a hammock",
        "public_id": "019d78ec-015e-76ad-ad61-25b5622d2f7c",
        "storage_key": "property/6767906449167444/019d78ec-015e-76ad-ad61-25b5622d2f7c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Gather around the fire pit on the patio with comfortable Adirondack chairs and relax in the hammock.",
      "link": "",
      "alt_text": "Outdoor fire pit with chairs and a hammock",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a62af7bf-c222-4eca-bf5e-c3e38de2d062",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78ec-0f64-74cd-87fd-4cbf38c5c242.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with Adirondack chairs and a mural on a building.",
        "public_id": "019d78ec-0f64-74cd-87fd-4cbf38c5c242",
        "storage_key": "property/6767906449167444/019d78ec-0f64-74cd-87fd-4cbf38c5c242.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax in the outdoor seating area with Adirondack chairs, perfect for enjoying the fresh air and unique mural art.",
      "link": "",
      "alt_text": "Outdoor seating area with Adirondack chairs and a mural on a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b46ea962-e47a-4f1d-9281-8b2d0e011767",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78ec-1351-701e-b7eb-93bfbe1e3dce.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with agility equipment and a fenced enclosure.",
        "public_id": "019d78ec-1351-701e-b7eb-93bfbe1e3dce",
        "storage_key": "property/6767906449167444/019d78ec-1351-701e-b7eb-93bfbe1e3dce.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility obstacles, providing a safe and fun space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Outdoor dog park with agility equipment and a fenced enclosure.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0664bfff-26a5-4d5f-9013-31235cc87569",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-f101-7123-a331-e1d2ba5a93a7.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with sinks, grill, and television.",
        "public_id": "019d78eb-f101-7123-a331-e1d2ba5a93a7",
        "storage_key": "property/6767906449167444/019d78eb-f101-7123-a331-e1d2ba5a93a7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and entertainment with this fully equipped outdoor kitchen, complete with sinks, a grill, and a large screen TV.",
      "link": "",
      "alt_text": "Outdoor kitchen area with sinks, grill, and television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bed6a7a6-468c-4fb7-8e06-1414d2c05d36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78ec-16de-711e-957b-a4bc788bb74a.webp",
      "image_media": {
        "alt_text": "Novo Sweetwater community entrance sign and road.",
        "public_id": "019d78ec-16de-711e-957b-a4bc788bb74a",
        "storage_key": "property/6767906449167444/019d78ec-16de-711e-957b-a4bc788bb74a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Novo Sweetwater. The property features a modern monument sign at the entrance, surrounded by lush landscaping and a winding road leading into the community.",
      "link": "",
      "alt_text": "Novo Sweetwater community entrance sign and road.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2a0377b-257a-4c46-9330-2936389e9543",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78ec-0a4e-74ba-91fb-a6f194f38135.webp",
      "image_media": {
        "alt_text": "Outdoor lawn area with cornhole game set up, patio furniture under a pergola, and lounge chairs on a paved area.",
        "public_id": "019d78ec-0a4e-74ba-91fb-a6f194f38135",
        "storage_key": "property/6767906449167444/019d78ec-0a4e-74ba-91fb-a6f194f38135.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor games and relaxation in this community space, featuring a cornhole set, comfortable seating under a shaded pergola, and lounging options on the patio.",
      "link": "",
      "alt_text": "Outdoor lawn area with cornhole game set up, patio furniture under a pergola, and lounge chairs on a paved area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2906e56-ae4e-441d-8660-9a9cf6d8f5bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78ec-0b19-7470-92da-fee20dfc5be3.webp",
      "image_media": {
        "alt_text": "Outdoor cabana with lounge chairs and a hammock.",
        "public_id": "019d78ec-0b19-7470-92da-fee20dfc5be3",
        "storage_key": "property/6767906449167444/019d78ec-0b19-7470-92da-fee20dfc5be3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor cabana, complete with comfortable lounge chairs and a serene hammock. Perfect for enjoying the beautiful weather.",
      "link": "",
      "alt_text": "Outdoor cabana with lounge chairs and a hammock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4cef0c0-b898-4f42-8dff-367b7f1502ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-d84e-76ba-aab8-23853be17c84.webp",
      "image_media": {
        "alt_text": "Modern fitness center with cardio equipment, weights, and benches.",
        "public_id": "019d78eb-d84e-76ba-aab8-23853be17c84",
        "storage_key": "property/6767906449167444/019d78eb-d84e-76ba-aab8-23853be17c84.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines, free weights, and workout benches. Your wellness journey starts here.",
      "link": "",
      "alt_text": "Modern fitness center with cardio equipment, weights, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f622756b-e6ca-410f-82ed-432e2128f1ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-fab9-75ca-899c-bc2ffdaa081b.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with grills and pool in the background.",
        "public_id": "019d78eb-fab9-75ca-899c-bc2ffdaa081b",
        "storage_key": "property/6767906449167444/019d78eb-fab9-75ca-899c-bc2ffdaa081b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our outdoor grilling station, perfectly situated next to the sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor kitchen area with grills and pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_01037c61-f6e7-41f5-a503-e2de8d9cffcb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-fb71-71b9-8178-72ac1d1b7d7f.webp",
      "image_media": {
        "alt_text": "Modern swimming pool with lounge chairs and a cabana area.",
        "public_id": "019d78eb-fb71-71b9-8178-72ac1d1b7d7f",
        "storage_key": "property/6767906449167444/019d78eb-fb71-71b9-8178-72ac1d1b7d7f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and a shaded cabana area.",
      "link": "",
      "alt_text": "Modern swimming pool with lounge chairs and a cabana area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51d7e86c-fe57-49e8-a03b-4274eb2d72d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-f088-70bb-972c-8e698310fd42.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with ping pong table, seating, and a view of the pool.",
        "public_id": "019d78eb-f088-70bb-972c-8e698310fd42",
        "storage_key": "property/6767906449167444/019d78eb-f088-70bb-972c-8e698310fd42.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy recreation and relaxation on the covered patio, featuring a ping pong table, comfortable seating, and views of the resort-style pool area.",
      "link": "",
      "alt_text": "Outdoor covered patio with ping pong table, seating, and a view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_42b18d10-be25-4d42-8424-d8ffa693b83b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-eb08-7096-becb-5beca2a74211.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with TRX equipment, free weights, treadmills, and stair climbers.",
        "public_id": "019d78eb-eb08-7096-becb-5beca2a74211",
        "storage_key": "property/6767906449167444/019d78eb-eb08-7096-becb-5beca2a74211.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines, weightlifting equipment, and functional training gear.",
      "link": "",
      "alt_text": "State-of-the-art fitness center with TRX equipment, free weights, treadmills, and stair climbers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23669b57-89f5-4c86-a3cc-32519e9b2c48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-ebd1-700f-b8ee-380a82336da2.webp",
      "image_media": {
        "alt_text": "Modern fitness center with cardio equipment, weights, and mirrors.",
        "public_id": "019d78eb-ebd1-700f-b8ee-380a82336da2",
        "storage_key": "property/6767906449167444/019d78eb-ebd1-700f-b8ee-380a82336da2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, free weights, and everything you need for a great workout.",
      "link": "",
      "alt_text": "Modern fitness center with cardio equipment, weights, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94d0c7c0-a9eb-48fa-9a2f-e781fc65b055",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-edd4-7138-a93f-7ac5c3abae63.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with seating and pool views.",
        "public_id": "019d78eb-edd4-7138-a93f-7ac5c3abae63",
        "storage_key": "property/6767906449167444/019d78eb-edd4-7138-a93f-7ac5c3abae63.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge, featuring comfortable seating and a refreshing pool just steps away.",
      "link": "",
      "alt_text": "Covered outdoor lounge area with seating and pool views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4e53780d-5917-451e-b907-6efe5a526141",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-d7ef-75cb-9c78-4204b02e6eab.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, seating areas, and kitchen.",
        "public_id": "019d78eb-d7ef-75cb-9c78-4204b02e6eab",
        "storage_key": "property/6767906449167444/019d78eb-d7ef-75cb-9c78-4204b02e6eab.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the community lounge, complete with a pool table, comfortable seating, and a kitchenette for resident use.",
      "link": "",
      "alt_text": "Community lounge with pool table, seating areas, and kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6fb5993c-771d-4ca1-b36d-e4a94d798b73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-d78a-757b-a31b-2eacf716c689.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and a bar.",
        "public_id": "019d78eb-d78a-757b-a31b-2eacf716c689",
        "storage_key": "property/6767906449167444/019d78eb-d78a-757b-a31b-2eacf716c689.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, complete with a pool table, comfortable seating, and a modern bar area.",
      "link": "",
      "alt_text": "Community lounge area with a pool table, seating, and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a19589fe-a593-4185-80b2-a98077ac9bb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-d47f-755b-8ece-7858d1d25726.webp",
      "image_media": {
        "alt_text": "Communal coffee bar and seating area in apartment building lobby.",
        "public_id": "019d78eb-d47f-755b-8ece-7858d1d25726",
        "storage_key": "property/6767906449167444/019d78eb-d47f-755b-8ece-7858d1d25726.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and a comfortable seating area in our community lounge.",
      "link": "",
      "alt_text": "Communal coffee bar and seating area in apartment building lobby.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c37e943-b2fb-4314-9d0e-149850e15e04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-d4f2-7206-8c57-13f2517ab7cd.webp",
      "image_media": {
        "alt_text": "Community kitchen and dining area with large live edge table and bar stools.",
        "public_id": "019d78eb-d4f2-7206-8c57-13f2517ab7cd",
        "storage_key": "property/6767906449167444/019d78eb-d4f2-7206-8c57-13f2517ab7cd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a communal dining experience in our stylish kitchen and gathering space, featuring a large live edge table perfect for sharing meals and conversation.",
      "link": "",
      "alt_text": "Community kitchen and dining area with large live edge table and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b723a628-3700-4d97-9532-fb8360984ae1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-d1a2-73bd-ad40-95cc065a497d.webp",
      "image_media": {
        "alt_text": "Clubhouse lounge area with seating, tables, and art.",
        "public_id": "019d78eb-d1a2-73bd-ad40-95cc065a497d",
        "storage_key": "property/6767906449167444/019d78eb-d1a2-73bd-ad40-95cc065a497d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and socialize in the community clubhouse lounge, featuring comfortable seating, dining tables, and modern art.",
      "link": "",
      "alt_text": "Clubhouse lounge area with seating, tables, and art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9c2d50c-66f6-4009-b949-7b17368e58a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-d011-7298-8da3-bcff0b278a3c.webp",
      "image_media": {
        "alt_text": "Leasing office desk with computer and chair.",
        "public_id": "019d78eb-d011-7298-8da3-bcff0b278a3c",
        "storage_key": "property/6767906449167444/019d78eb-d011-7298-8da3-bcff0b278a3c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Visit our leasing office to learn more about our apartment community and find your perfect home.",
      "link": "",
      "alt_text": "Leasing office desk with computer and chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20a67c23-1414-44c6-bc88-a3c7a82577b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-cf4a-77ec-af70-45dcf088372b.webp",
      "image_media": {
        "alt_text": "In-unit laundry room with washer and dryer",
        "public_id": "019d78eb-cf4a-77ec-af70-45dcf088372b",
        "storage_key": "property/6767906449167444/019d78eb-cf4a-77ec-af70-45dcf088372b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities make chores a breeze, featuring a washer and dryer with overhead storage.",
      "link": "",
      "alt_text": "In-unit laundry room with washer and dryer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67b81763-b803-45ff-b676-0c0d2c0944d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-cbeb-735b-809d-f8f623c5102f.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, navy blue accent wall, and walk-in closet.",
        "public_id": "019d78eb-cbeb-735b-809d-f8f623c5102f",
        "storage_key": "property/6767906449167444/019d78eb-cbeb-735b-809d-f8f623c5102f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable king-size bed, a stylish navy blue accent wall adorned with abstract art, and a convenient walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, navy blue accent wall, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c8babe89-5c88-4adf-b9a2-3eda36be6413",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-cdbc-730d-8935-e4fff404410f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and a toilet.",
        "public_id": "019d78eb-cdbc-730d-8935-e4fff404410f",
        "storage_key": "property/6767906449167444/019d78eb-cdbc-730d-8935-e4fff404410f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed bathroom featuring a double vanity with granite countertops, a large mirror, and a modern toilet. Perfect for a comfortable living experience.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, granite countertops, and a toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c236a13-44f4-499e-a903-cd9350d669df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-aaa7-76cb-9996-584ef327d24c.webp",
      "image_media": {
        "alt_text": "Living room with a blue couch, leather accent chair, coffee table, and desk.",
        "public_id": "019d78eb-aaa7-76cb-9996-584ef327d24c",
        "storage_key": "property/6767906449167444/019d78eb-aaa7-76cb-9996-584ef327d24c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable blue sofa, a chic leather armchair, a modern coffee table, and a dedicated workspace with a desk and chair. Perfect for relaxation and productivity.",
      "link": "",
      "alt_text": "Living room with a blue couch, leather accent chair, coffee table, and desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce0d8e5a-f104-4831-971e-070752a7e73a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-b1b6-7625-b451-fe50c240d10d.webp",
      "image_media": {
        "alt_text": "Exterior of a modern multifamily building with white siding and large dark-framed windows.",
        "public_id": "019d78eb-b1b6-7625-b451-fe50c240d10d",
        "storage_key": "property/6767906449167444/019d78eb-b1b6-7625-b451-fe50c240d10d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Discover the modern charm of our multifamily property's exterior, featuring sleek white siding and expansive windows.",
      "link": "",
      "alt_text": "Exterior of a modern multifamily building with white siding and large dark-framed windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a1d2f373-f87a-400d-be92-8914d2296070",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-aa9e-77ad-b863-278b2de9b704.webp",
      "image_media": {
        "alt_text": "Living room with a large blue sofa, coffee table, armchair, TV, and a large plant.",
        "public_id": "019d78eb-aa9e-77ad-b863-278b2de9b704",
        "storage_key": "property/6767906449167444/019d78eb-aa9e-77ad-b863-278b2de9b704.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern and comfortable living room featuring a plush blue sofa, stylish coffee table, and entertainment center with a flat-screen TV.",
      "link": "",
      "alt_text": "Living room with a large blue sofa, coffee table, armchair, TV, and a large plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7f68e0a-1841-4bf1-bcd2-94d97d27cc8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-abcc-7490-8325-338d00be18b1.webp",
      "image_media": {
        "alt_text": "A bedroom with a king-sized bed, modern art, and a leather accent chair.",
        "public_id": "019d78eb-abcc-7490-8325-338d00be18b1",
        "storage_key": "property/6767906449167444/019d78eb-abcc-7490-8325-338d00be18b1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our spacious bedrooms, featuring plush bedding, contemporary decor, and ample natural light.",
      "link": "",
      "alt_text": "A bedroom with a king-sized bed, modern art, and a leather accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_102df797-0cde-4dcb-95fb-c15b46b17b39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-b1a0-73bf-9495-77d24e7d8fbc.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with a blue sofa, accent chair, and island.",
        "public_id": "019d78eb-b1a0-73bf-9495-77d24e7d8fbc",
        "storage_key": "property/6767906449167444/019d78eb-b1a0-73bf-9495-77d24e7d8fbc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to a modern kitchen, featuring stylish furniture and ample natural light.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with a blue sofa, accent chair, and island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58864869-e508-461a-8113-6cee0efad918",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-a9fa-758c-8865-1d294cb56abd.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island seating and dining table.",
        "public_id": "019d78eb-a9fa-758c-8865-1d294cb56abd",
        "storage_key": "property/6767906449167444/019d78eb-a9fa-758c-8865-1d294cb56abd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and kitchen area featuring a large island with seating, a dining area, and a comfortable living room space.",
      "link": "",
      "alt_text": "Modern kitchen and living area with island seating and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31259d83-e9b2-407c-8064-82afe905076e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-ab17-7604-8d7a-02e94df5757a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with seating.",
        "public_id": "019d78eb-ab17-7604-8d7a-02e94df5757a",
        "storage_key": "property/6767906449167444/019d78eb-ab17-7604-8d7a-02e94df5757a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen featuring ample cabinet space, sleek stainless steel appliances, and a convenient island perfect for casual dining or entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_083eb8b5-ea94-49ea-a1c0-8a9801419e8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-ab59-77a5-bada-61e7fe6335dd.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of a modern apartment with blue sofa and white cabinets.",
        "public_id": "019d78eb-ab59-77a5-bada-61e7fe6335dd",
        "storage_key": "property/6767906449167444/019d78eb-ab59-77a5-bada-61e7fe6335dd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room and kitchen, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area of a modern apartment with blue sofa and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fcfe58d2-f17d-4ea5-8e07-8fb490083173",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-aaa6-7578-9840-59c655d01fb2.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and a large parking lot.",
        "public_id": "019d78eb-aaa6-7578-9840-59c655d01fb2",
        "storage_key": "property/6767906449167444/019d78eb-aaa6-7578-9840-59c655d01fb2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of a contemporary apartment complex's exterior, featuring multi-level balconies and ample parking. Offers a welcoming first impression.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and a large parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b1ea0426-413c-423c-b94a-4b058790d3e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d78eb-aa9d-772a-b26a-5e0fe78c2f85.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "019d78eb-aa9d-772a-b26a-5e0fe78c2f85",
        "storage_key": "property/6767906449167444/019d78eb-aa9d-772a-b26a-5e0fe78c2f85.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, high-end stainless steel appliances, and a generous island perfect for dining and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6166243c-9991-4f4a-b0d8-0e712946ab6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "970 W Pointe Ct, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "People say this restaurant serves delicious pancakes, hashbrown casserole, and meatloaf. They also highlight the fast service, reasonable prices, and friendly staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-28ca-701f-8ca7-e99e975d8232.webp",
      "poi_featured_image_media": {
        "alt_text": "Cracker Barrel Old Country Store with rocking chairs and blooming trees.",
        "public_id": "019d72d1-28ca-701f-8ca7-e99e975d8232",
        "storage_key": "property/6767906449167444/019d72d1-28ca-701f-8ca7-e99e975d8232.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ga/lithia-springs/543/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=14550607236029033162&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "33.7745722",
      "poi_longitude": "-84.60584039999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-398-8568",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
      "poi_map_icon_media": {
        "alt_text": "Flatware icon",
        "public_id": "019d72d2-2f4b-7040-87e5-648656b5593f",
        "storage_key": "property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1Iw4qkY9YgRyiq9UTAk7sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_67093b49-8502-4152-8bbe-8c194044cdc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "835 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Diners say this chicken restaurant offers delicious chicken sandwiches and fresh food, and they appreciate the friendly and helpful staff. They also highlight the efficient drive-thru and quick service.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-2b0d-724f-b5fb-e609f2f42b7a.webp",
      "poi_featured_image_media": {
        "alt_text": "Chick-fil-A restaurant exterior with the Chick-fil-A logo displayed prominently.",
        "public_id": "019d72d1-2b0d-724f-b5fb-e609f2f42b7a",
        "storage_key": "property/6767906449167444/019d72d1-2b0d-724f-b5fb-e609f2f42b7a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/thornton-road?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4072200735377806462&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.7820861",
      "poi_longitude": "-84.6097319",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-732-8034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
      "poi_map_icon_media": {
        "alt_text": "Flatware icon",
        "public_id": "019d72d2-2f4b-7040-87e5-648656b5593f",
        "storage_key": "property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1bGe4Qgi9YgRflRHTv5cgzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_f3b8415f-bd0e-4f9e-bddd-1349621fca81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "High Noon Brunchery",
      "poi_type": "Restaurants",
      "poi_address": "8440 Courthouse Square E, Douglasville, GA 30134, USA",
      "poi_short_description": "Pretty restaurant serving brunchfare, plus vegan options and mimosas.",
      "poi_long_description": "People say this breakfast restaurant serves delicious pancakes, fried chicken, and grits. They highlight the fun vibe and the generous portions. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-3bda-7726-94bb-4c6e69710479.webp",
      "poi_featured_image_media": {
        "alt_text": "Pink dining room with tables and chairs",
        "public_id": "019d72d1-3bda-7726-94bb-4c6e69710479",
        "storage_key": "property/6767906449167444/019d72d1-3bda-7726-94bb-4c6e69710479.webp",
        "width": 1179,
        "height": 664
      },
      "poi_business_url": "https://www.highnoonbrunchery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17968447204288846208&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "high-noon-brunchery",
      "poi_latitude": "33.750505",
      "poi_longitude": "-84.74993909999999",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-398-7853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
      "poi_map_icon_media": {
        "alt_text": "Flatware icon",
        "public_id": "019d72d2-2f4b-7040-87e5-648656b5593f",
        "storage_key": "property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ69FEr0n9YgRgFn_CIi_XPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_f92c6f5e-7b52-4517-8ef8-051ee462dec0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Gumbeaux's, A Cajun Cafe",
      "poi_type": "Restaurants",
      "poi_address": "12407 Veterans Memorial Hwy, Douglasville, GA 30134, USA",
      "poi_short_description": "Popular, New Orleans-style eatery dishing up Cajun favorites in a lively, easygoing setting.",
      "poi_long_description": "People say this Cajun restaurant serves delicious seafood gumbo, stuffed shrimp, and salmon teriyaki. They highlight the large portions, reasonable prices, and authentic New Orleans atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-2a56-730c-a5a9-5f66be607aeb.webp",
      "poi_featured_image_media": {
        "alt_text": "Exit door with Louisiana State University flags and \"New Orleans Jazz & Heritage Festival\" banner.",
        "public_id": "019d72d1-2a56-730c-a5a9-5f66be607aeb",
        "storage_key": "property/6767906449167444/019d72d1-2a56-730c-a5a9-5f66be607aeb.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.gumbeauxs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5708299481446411655&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gumbeauxs-a-cajun-cafe",
      "poi_latitude": "33.750674",
      "poi_longitude": "-84.74932",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-947-8288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
      "poi_map_icon_media": {
        "alt_text": "Flatware icon",
        "public_id": "019d72d2-2f4b-7040-87e5-648656b5593f",
        "storage_key": "property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWpXNUAm9YgRh-0obyL0N08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_10a9a3b2-da04-4553-8cd9-e64891709e8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Bay Breeze",
      "poi_type": "Restaurants",
      "poi_address": "1440 Veterans Memorial Hwy SW, Mableton, GA 30126, USA",
      "poi_short_description": "Big, casual seafood eatery with fried & broiled platters, a lighthouse mural & communal seating.",
      "poi_long_description": "People say this seafood restaurant serves delicious fried catfish, shrimp, and other seafood dishes. They also highlight the generous portions, reasonable prices, and friendly service.\n\nOther reviews mention the food can be under-seasoned.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-2b2e-76f0-a67f-27b609a715de.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a restaurant with tables and chairs, featuring nautical-themed murals.",
        "public_id": "019d72d1-2b2e-76f0-a67f-27b609a715de",
        "storage_key": "property/6767906449167444/019d72d1-2b2e-76f0-a67f-27b609a715de.webp",
        "width": 3072,
        "height": 1384
      },
      "poi_business_url": "http://www.baybreezeofatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6577809041943086451&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bay-breeze",
      "poi_latitude": "33.815723",
      "poi_longitude": "-84.59629120000001",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-745-0905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
      "poi_map_icon_media": {
        "alt_text": "Flatware icon",
        "public_id": "019d72d2-2f4b-7040-87e5-648656b5593f",
        "storage_key": "property/6767906449167444/019d72d2-2f4b-7040-87e5-648656b5593f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoYFW1nwY9YgRc8VeEXkSSVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_ae354d32-67dd-40a3-a54b-c3a17a423095",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Arbor Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "6700 Douglas Blvd, Douglasville, GA 30135, USA",
      "poi_short_description": "Mall with a standard range of department stores & specialty shops, a movie theater & a food court.",
      "poi_long_description": "Mall with a standard range of department stores & specialty shops, a movie theater & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-3931-73b2-b53e-88502e86ea09.webp",
      "poi_featured_image_media": {
        "alt_text": "Dillard's department store entrance with signage and displays.",
        "public_id": "019d72d1-3931-73b2-b53e-88502e86ea09",
        "storage_key": "property/6767906449167444/019d72d1-3931-73b2-b53e-88502e86ea09.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.arborplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5711262346315518379&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arbor-place",
      "poi_latitude": "33.7286719",
      "poi_longitude": "-84.74465130000002",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-947-4244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-300d-766e-a5f2-be6fc2bd316f.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d72d2-300d-766e-a5f2-be6fc2bd316f",
        "storage_key": "property/6767906449167444/019d72d2-300d-766e-a5f2-be6fc2bd316f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB9MvIrMn9YgRq1EzK9h6Qk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_322159f3-5d70-470c-81a3-ba27fb275402",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has friendly and helpful staff, and they appreciate the military discount offered. They also highlight that the store is well-stocked, clean, and organized.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-4875-72ee-9bc4-4cfb7f7cfa76.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot store exterior with grills displayed outside.",
        "public_id": "019d72d1-4875-72ee-9bc4-4cfb7f7cfa76",
        "storage_key": "property/6767906449167444/019d72d1-4875-72ee-9bc4-4cfb7f7cfa76.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.homedepot.com/l/Lithia-Spgs-Thornton-Rd/GA/Lithia-Springs/30122/6941?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8496950718607151784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.7788577",
      "poi_longitude": "-84.6105877",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-732-0184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-300d-766e-a5f2-be6fc2bd316f.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d72d2-300d-766e-a5f2-be6fc2bd316f",
        "storage_key": "property/6767906449167444/019d72d2-300d-766e-a5f2-be6fc2bd316f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDY8tFAYi9YgRqFKU6Kg763U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_ee0b5c61-27d3-4d4c-807c-14bb79693842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Talpa Supermercados - Mableton GA",
      "poi_type": "Shopping & Retail",
      "poi_address": "1245 Veterans Memorial Hwy SW, Mableton, GA 30126, USA",
      "poi_short_description": "Chain grocery store and market with produce, meats, and baked goods, plus an eatery.",
      "poi_long_description": "People say this supermarket offers excellent quality food, including fresh meat, fruits, and vegetables, and traditional Mexican groceries. They also highlight the great prices, clean and organized store, and delicious hot food and desserts.\n\nOther reviews mention the customer service can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-3b88-701e-b3e7-bc3ab1cd446a.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of Talpa Supermercados with a \"Now Open\" banner and people entering the store.",
        "public_id": "019d72d1-3b88-701e-b3e7-bc3ab1cd446a",
        "storage_key": "property/6767906449167444/019d72d1-3b88-701e-b3e7-bc3ab1cd446a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.supermercadostalpa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15641591351909472529&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "talpa-supermercados---mableton-ga",
      "poi_latitude": "33.8154744",
      "poi_longitude": "-84.5906389",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 678-903-5766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-3013-7299-b0ad-51d8c065c572.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d72d2-3013-7299-b0ad-51d8c065c572",
        "storage_key": "property/6767906449167444/019d72d2-3013-7299-b0ad-51d8c065c572.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8BR2ZQZ9YgREdliPHYYEtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8cb1dcb7-22d3-4bb1-98c6-80229bdfbd77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "2WEARS",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 Wharton Cir SW, Atlanta, GA 30336, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this used clothing store offers a large selection of clothes, shoes, and jewelry, with a small section for vintage items. They also highlight the great prices, the spacious and well-organized layout, and the friendly and helpful staff.\n\nOther reviews mention the pricing can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-48d8-753a-8aa5-4bb9cd9b2fa6.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a thrift store with colorful murals and racks of clothes.",
        "public_id": "019d72d1-48d8-753a-8aa5-4bb9cd9b2fa6",
        "storage_key": "property/6767906449167444/019d72d1-48d8-753a-8aa5-4bb9cd9b2fa6.webp",
        "width": 2313,
        "height": 3072
      },
      "poi_business_url": "https://2wears.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13495972939917173620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "2wears",
      "poi_latitude": "33.7549468",
      "poi_longitude": "-84.5562059",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 45 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-904-4573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-300d-766e-a5f2-be6fc2bd316f.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d72d2-300d-766e-a5f2-be6fc2bd316f",
        "storage_key": "property/6767906449167444/019d72d2-300d-766e-a5f2-be6fc2bd316f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJayw88Rgf9YgRdCMMVuJTS7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_f2245fe7-bb77-4759-8324-0296aa0077bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Publix Super Market at Paradise Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "2675 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh produce, bakery items, and grocery products. They also highlight the convenient location, friendly staff, and clean store.\n\nOther reviews mention the deli service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-29e9-76f4-a3a6-f868ed5063f6.webp",
      "poi_featured_image_media": {
        "alt_text": "Publix grocery store exterior with signage.",
        "public_id": "019d72d1-29e9-76f4-a3a6-f868ed5063f6",
        "storage_key": "property/6767906449167444/019d72d1-29e9-76f4-a3a6-f868ed5063f6.webp",
        "width": 1536,
        "height": 2560
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=730&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=12589170373325593169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-paradise-crossing",
      "poi_latitude": "33.7353303",
      "poi_longitude": "-84.6688539",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-920-3471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-3013-7299-b0ad-51d8c065c572.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d72d2-3013-7299-b0ad-51d8c065c572",
        "storage_key": "property/6767906449167444/019d72d2-3013-7299-b0ad-51d8c065c572.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkx3DChQh9YgRUZrxFsG3ta4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_d9c7fd1f-6c14-4f73-a0f0-ec6acb5c7f54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "South Cobb Regional Library",
      "poi_type": "Education",
      "poi_address": "805 Clay Rd, Mableton, GA 30126, USA",
      "poi_short_description": "Spacious public library featuring kid-friendly storytime and a seasonal reading program.",
      "poi_long_description": "People say this public library offers a wide selection of books, movies, and resources, including a seed library, scavenger hunts, and a 3D printer. They highlight the peaceful atmosphere, the fun children's area, and the availability of private study rooms. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-56cb-75a4-9ace-145f6a11cd62.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior signage for South Cobb Regional Library at 805 Clay Road.",
        "public_id": "019d72d1-56cb-75a4-9ace-145f6a11cd62",
        "storage_key": "property/6767906449167444/019d72d1-56cb-75a4-9ace-145f6a11cd62.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.cobbcounty.org/library/locations/south-cobb-regional-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=10410195068367311748&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-cobb-regional-library",
      "poi_latitude": "33.8251194",
      "poi_longitude": "-84.57758009999999",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 678-398-5828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f9e-75e4-987c-0f2a01c99da0.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d72d2-2f9e-75e4-987c-0f2a01c99da0",
        "storage_key": "property/6767906449167444/019d72d2-2f9e-75e4-987c-0f2a01c99da0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF21T9EQY9YgRhJOOVEJxeJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_9f3f35e4-be0d-408d-9595-0194fe4e6f72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Hurricane Harbor",
      "poi_type": "Entertainment",
      "poi_address": "6 Flags Wy SW, Austell, GA 30168, USA",
      "poi_short_description": "Water park featuring a wave pool, VIP lounge, and restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-5997-729a-94c5-775015178971.webp",
      "poi_featured_image_media": {
        "alt_text": "Hurricane Harbor water park with wave pool and water slides",
        "public_id": "019d72d1-5997-729a-94c5-775015178971",
        "storage_key": "property/6767906449167444/019d72d1-5997-729a-94c5-775015178971.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.sixflags.com/hurricaneharborla",
      "poi_directions_map_url": "https://maps.google.com/?cid=2937357843343186586&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hurricane-harbor",
      "poi_latitude": "33.7648177",
      "poi_longitude": "-84.5520421",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-739-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlx6jXc0e9YgRmpqtTmWXwyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_e1d5d3de-c7c2-4a2d-9b82-311a4ae0227d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Paradise Island",
      "poi_type": "Entertainment",
      "poi_address": "275 Riverside Pkwy, Austell, GA 30168, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-5a07-75fb-9610-cdf4125de14d.webp",
      "poi_featured_image_media": {
        "alt_text": "Six Flags Hurricane Harbor wave pool with water slides and people swimming.",
        "public_id": "019d72d1-5a07-75fb-9610-cdf4125de14d",
        "storage_key": "property/6767906449167444/019d72d1-5a07-75fb-9610-cdf4125de14d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.sixflags.com/overgeorgia/attractions/paradise-island",
      "poi_directions_map_url": "https://maps.google.com/?cid=13654238607484463232&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "paradise-island",
      "poi_latitude": "33.7652294",
      "poi_longitude": "-84.5522854",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-739-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJURzvN80e9YgRgCiJlauZfb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_6c92a021-e1a2-441d-8151-de26bbe398ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Douglas County Museum of History and Art",
      "poi_type": "Entertainment",
      "poi_address": "12431 Veterans Memorial Hwy, Douglasville, GA 30134, USA",
      "poi_short_description": "Complimentary history museum in a former 1998 courthouse with 12 exhibition rooms & a gift shop.",
      "poi_long_description": "Complimentary history museum in a former 1998 courthouse with 12 exhibition rooms & a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-755d-71de-8672-ef75657556ce.webp",
      "poi_featured_image_media": {
        "alt_text": "The Old Douglas County Courthouse, now the \"Matthews\" museum of history and art.",
        "public_id": "019d72d1-755d-71de-8672-ef75657556ce",
        "storage_key": "property/6767906449167444/019d72d1-755d-71de-8672-ef75657556ce.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://dcmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3911744864939571949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "douglas-county-museum-of-history-and-art",
      "poi_latitude": "33.750204",
      "poi_longitude": "-84.7503643",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-449-3939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2e8c-7752-9596-c516f0ba8ed6.webp",
      "poi_map_icon_media": {
        "alt_text": "Property logo",
        "public_id": "019d72d2-2e8c-7752-9596-c516f0ba8ed6",
        "storage_key": "property/6767906449167444/019d72d2-2e8c-7752-9596-c516f0ba8ed6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMeIaREAm9YgR7XqutjpPSTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e30c158c-2a06-40ac-9b4e-60bdfbdc4f1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Selfie Paradise Museum",
      "poi_type": "Entertainment",
      "poi_address": "6700 Douglas Blvd space 1000, Douglasville, GA 30135, USA",
      "poi_short_description": "Creative, colorful selfie studio featuring a retro diner, sand, confetti, a basketball arcade game and hammocks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-65a5-7465-93ff-35d990b9db7f.webp",
      "poi_featured_image_media": {
        "alt_text": "Woman in yellow outfit posing with takeout bag and sweets.",
        "public_id": "019d72d1-65a5-7465-93ff-35d990b9db7f",
        "storage_key": "property/6767906449167444/019d72d1-65a5-7465-93ff-35d990b9db7f.webp",
        "width": 527,
        "height": 823
      },
      "poi_business_url": "http://www.selfieparadise.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=375765236235586518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "selfie-paradise-museum",
      "poi_latitude": "33.7277245",
      "poi_longitude": "-84.74608350000001",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-955-7353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2e8c-7752-9596-c516f0ba8ed6.webp",
      "poi_map_icon_media": {
        "alt_text": "Property logo",
        "public_id": "019d72d2-2e8c-7752-9596-c516f0ba8ed6",
        "storage_key": "property/6767906449167444/019d72d2-2e8c-7752-9596-c516f0ba8ed6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvXn79Zcn9YgR1kvD0H38NgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_31048956-33c1-4337-8ab3-1ab45a37174f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Falcon Stadium",
      "poi_type": "Entertainment",
      "poi_address": "991 Old Alabama Rd SW, Mableton, GA 30126, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-68cb-724a-8b20-3072c2e3e9ef.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of Pebblebrook Falcons football field with bleachers and surrounding trees.",
        "public_id": "019d72d1-68cb-724a-8b20-3072c2e3e9ef",
        "storage_key": "property/6767906449167444/019d72d1-68cb-724a-8b20-3072c2e3e9ef.webp",
        "width": 2621,
        "height": 1747
      },
      "poi_business_url": "https://stadiumconnection.com/ga/stadium.php?id=4566",
      "poi_directions_map_url": "https://maps.google.com/?cid=17294815458211452063&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "falcon-stadium",
      "poi_latitude": "33.8048164",
      "poi_longitude": "-84.5817794",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2ed7-76b1-9dc8-43161c7d1f8e.webp",
      "poi_map_icon_media": {
        "alt_text": "Abstract illustration of two people sitting at a table.",
        "public_id": "019d72d2-2ed7-76b1-9dc8-43161c7d1f8e",
        "storage_key": "property/6767906449167444/019d72d2-2ed7-76b1-9dc8-43161c7d1f8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCcHJdPQZ9YgRn9SgAgeHA_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_7a0fa6ab-f50f-4319-8fc9-91209aeaafa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Onelife Fitness Douglasville",
      "poi_type": "Health and Wellness",
      "poi_address": "9365 The Landing Dr, Douglasville, GA 30135, USA",
      "poi_short_description": "Large chain offering cardiovascular machines, classes, a pool and saunas for exercise.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and amenities, including a pool, sauna, and kids club. They also highlight the clean facilities, friendly and helpful staff, and motivating atmosphere.\n\nOther reviews mention the hours can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-67a9-712c-a47c-4081233cbff3.webp",
      "poi_featured_image_media": {
        "alt_text": "Fitness center with treadmills and other cardio equipment.",
        "public_id": "019d72d1-67a9-712c-a47c-4081233cbff3",
        "storage_key": "property/6767906449167444/019d72d1-67a9-712c-a47c-4081233cbff3.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.onelifefitness.com/gyms/douglasville",
      "poi_directions_map_url": "https://maps.google.com/?cid=6863370107242590997&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "onelife-fitness-douglasville",
      "poi_latitude": "33.7288833",
      "poi_longitude": "-84.74042419999999",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-949-1116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRSi1Nsn9YgRFbM6tL-WP18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1c6c51cb-df57-490f-accd-a0a6a6a0b0cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "MadHouse Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "1338 Veterans Memorial Hwy SW #110, Mableton, GA 30126, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment and machines, including specialty equipment and posing rooms. They highlight the spacious layout, the inspiring atmosphere with serious bodybuilders, and the friendly and helpful staff. They also like that it's open 24/7 and never crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-8100-726d-8539-2d5cf95db4c0.webp",
      "poi_featured_image_media": {
        "alt_text": "Madhouse Gym with \"Heaviest Kegs & Dumbbells in the World\" sign, weight racks, kegs, dumbbells, and a grim reaper decoration.",
        "public_id": "019d72d1-8100-726d-8539-2d5cf95db4c0",
        "storage_key": "property/6767906449167444/019d72d1-8100-726d-8539-2d5cf95db4c0.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.madhousegymgeorgia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3651053684589426435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madhouse-gym",
      "poi_latitude": "33.8165206",
      "poi_longitude": "-84.5947036",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-343-8458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJywLWyy0Z9YgRA3fVZfslqzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0e6e5f20-f2de-4e52-9c6f-f53f649a673a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5590 Mableton Pkwy, Mableton, GA 30126, USA",
      "poi_short_description": "Budget-friendly chain featuring a gym and workout machines plus massage beds, hydro-massage beds and tanning facilities.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, including Hammer Strength machines. They also highlight the clean and spacious environment, and the friendly, helpful, and professional staff.\n\nOther reviews mention the showers can lack hot water.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-8055-72ff-a924-0bd9c8b20d1c.webp",
      "poi_featured_image_media": {
        "alt_text": "A vibrant Planet Fitness gym with many people working out on purple and yellow machines.",
        "public_id": "019d72d1-8055-72ff-a924-0bd9c8b20d1c",
        "storage_key": "property/6767906449167444/019d72d1-8055-72ff-a924-0bd9c8b20d1c.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/mableton-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11819712965298475632&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.8170329",
      "poi_longitude": "-84.5798535",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-732-0076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYxS31sY9YgRcNKxg1EOCKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_985def2b-e9b5-4d9e-9b10-d2bbd19cb3ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3020 Chapel Hill Rd, Douglasville, GA 30135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym is clean and has friendly and knowledgeable staff. They also highlight the variety of classes, especially spin class, and the abundance of equipment.\n\nSome reviews mention the sauna can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-8610-7458-b114-3a8d48042068.webp",
      "poi_featured_image_media": {
        "alt_text": "Spacious and modern gym with various weight machines, cardio equipment, and a turf training area.",
        "public_id": "019d72d1-8610-7458-b114-3a8d48042068",
        "storage_key": "property/6767906449167444/019d72d1-8610-7458-b114-3a8d48042068.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=568&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10327416256436495742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.7246893",
      "poi_longitude": "-84.732046",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-202-5613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMR9hzAAn9YgRfuV9RF5aUo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b6573531-8e37-41a2-8e0e-a1e3f701b278",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Westside Animal Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "875 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-84e9-7486-8f5f-e97e0a380bd9.webp",
      "poi_featured_image_media": {
        "alt_text": "Emergency Animal Hospital building with brick exterior and signage.",
        "public_id": "019d72d1-84e9-7486-8f5f-e97e0a380bd9",
        "storage_key": "property/6767906449167444/019d72d1-84e9-7486-8f5f-e97e0a380bd9.webp",
        "width": 555,
        "height": 327
      },
      "poi_business_url": "https://westsideemergency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8518008787118232302&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westside-animal-emergency-clinic",
      "poi_latitude": "33.7798488",
      "poi_longitude": "-84.6091757",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 470-412-7297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJERiShggi9YgR7pLWjdwLNnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_12846734-e3f4-4ae9-9b1d-b43ed0471ecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "The Times Nail Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "2562 Fairburn Rd Suite G10, Douglasville, GA 30135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-893d-7142-a887-0f3043a03918.webp",
      "poi_featured_image_media": {
        "alt_text": "The Times Nail Lounge logo with services and contact information.",
        "public_id": "019d72d1-893d-7142-a887-0f3043a03918",
        "storage_key": "property/6767906449167444/019d72d1-893d-7142-a887-0f3043a03918.webp",
        "width": 1332,
        "height": 750
      },
      "poi_business_url": "https://tinyurl.com/mr3vzct5",
      "poi_directions_map_url": "https://maps.google.com/?cid=5765790701774720612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-times-nail-lounge",
      "poi_latitude": "33.7352059",
      "poi_longitude": "-84.6708354",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 470-308-3945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUtUWMgh9YgRZE6IRBg0BFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_452e17b8-a836-4a99-b51d-5d2a108780ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Phoenix Nail Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "9365 The Landing Dr Suite E200 & E300, Douglasville, GA 30135, USA",
      "poi_short_description": "Relaxed salon featuring manicures, pedicures and gel polish, alongside waxing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-9d80-73ff-83ac-50ada6134cd9.webp",
      "poi_featured_image_media": {
        "alt_text": "Phoenix Nail Spa logo and promotional image with text 'Enjoy the true relaxation' and phone number.",
        "public_id": "019d72d1-9d80-73ff-83ac-50ada6134cd9",
        "storage_key": "property/6767906449167444/019d72d1-9d80-73ff-83ac-50ada6134cd9.webp",
        "width": 2133,
        "height": 789
      },
      "poi_business_url": "https://phoenixnaildouglasville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10044689681445794975&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-nail-spa",
      "poi_latitude": "33.7278458",
      "poi_longitude": "-84.7402281",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-401-7369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXRO1z_0n9YgRn7Sb1QvoZYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_b70789be-c2e4-4dd0-8e67-cf1fb1304905",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "EpiFIT Club",
      "poi_type": "Health and Wellness",
      "poi_address": "135 Riverside Pkwy, Austell, GA 30168, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of amenities, including a sauna, steam room, whirlpool, indoor track, and basketball court. They highlight the clean and modern facility, and the welcoming, community-focused vibe. They also like the kind and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-9cce-76ec-9c8f-4e167416b9d7.webp",
      "poi_featured_image_media": {
        "alt_text": "People cycling indoors in a fitness class.",
        "public_id": "019d72d1-9cce-76ec-9c8f-4e167416b9d7",
        "storage_key": "property/6767906449167444/019d72d1-9cce-76ec-9c8f-4e167416b9d7.webp",
        "width": 2048,
        "height": 1151
      },
      "poi_business_url": "http://epifitclub.com/membership",
      "poi_directions_map_url": "https://maps.google.com/?cid=14949230480426946506&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "epifit-club",
      "poi_latitude": "33.771969",
      "poi_longitude": "-84.55731589999999",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-903-5482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSbSPni4Z9YgRyk9K4-pVds8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e12de091-813a-4e2c-ad8c-2fa44689a17f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "D1 Barber Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "9375 The Landing Dr Suite G-140, Douglasville, GA 30135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-a440-7726-947a-b75e0bd97356.webp",
      "poi_featured_image_media": {
        "alt_text": "Barber in chair with arms outstretched surrounded by mist, with the \"D1 Barbers\" logo in the background.",
        "public_id": "019d72d1-a440-7726-947a-b75e0bd97356",
        "storage_key": "property/6767906449167444/019d72d1-a440-7726-947a-b75e0bd97356.webp",
        "width": 2048,
        "height": 3072
      },
      "poi_business_url": "http://d1barberloungeatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6961784805723475251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "d1-barber-lounge",
      "poi_latitude": "33.728231",
      "poi_longitude": "-84.7385347",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-633-8658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_5xXAgn9YgRMw3cS2U6nWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_79811b13-f7ee-43f3-b2d5-adbe15d63b93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Wellstar Douglas Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "8954 Hospital Dr, Douglasville, GA 30134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-a3d9-77b0-9848-a03abaeb3519.webp",
      "poi_featured_image_media": {
        "alt_text": "Wellstar Douglas Medical Center building exterior with signage.",
        "public_id": "019d72d1-a3d9-77b0-9848-a03abaeb3519",
        "storage_key": "property/6767906449167444/019d72d1-a3d9-77b0-9848-a03abaeb3519.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.wellstar.org/locations/hospital/douglas-medical-center?utm_medium=listing&utm_source=google&utm_content=Wellstar_Douglas_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6293250609189929855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wellstar-douglas-medical-center",
      "poi_latitude": "33.7390326",
      "poi_longitude": "-84.7314746",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 470-644-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f4e-74f4-b3e1-affcf707cf27.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d72d2-2f4e-74f4-b3e1-affcf707cf27",
        "storage_key": "property/6767906449167444/019d72d2-2f4e-74f4-b3e1-affcf707cf27.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWWRGvgm9YgRf8NGAxYeVlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7ab3c6a8-a733-41bc-b561-9448ce9197ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Resurgens Orthopaedics",
      "poi_type": "Health and Wellness",
      "poi_address": "6001 Professional Pkwy #1040, Douglasville, GA 30134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-aac8-7382-8b2c-c7e9638b271d.webp",
      "poi_featured_image_media": {
        "alt_text": "Building entrance with covered walkway and brick pillars.",
        "public_id": "019d72d1-aac8-7382-8b2c-c7e9638b271d",
        "storage_key": "property/6767906449167444/019d72d1-aac8-7382-8b2c-c7e9638b271d.webp",
        "width": 1600,
        "height": 900
      },
      "poi_business_url": "https://www.resurgens.com/douglasville?utm_medium=organic&utm_source=GMBLocation&utm_content=Douglasville",
      "poi_directions_map_url": "https://maps.google.com/?cid=3576538610904616429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "resurgens-orthopaedics",
      "poi_latitude": "33.7406083",
      "poi_longitude": "-84.72773889999999",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-847-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f4e-74f4-b3e1-affcf707cf27.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d72d2-2f4e-74f4-b3e1-affcf707cf27",
        "storage_key": "property/6767906449167444/019d72d2-2f4e-74f4-b3e1-affcf707cf27.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWAYZfcm9YgR7U1w1OpqojE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_a89451e7-9c88-4f95-9568-827b5bc14bed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Sweetwater Creek State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1750 Mt Vernon Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Historical wooded state park offering hiking, picnicking & boating, plus fishing.",
      "poi_long_description": "Visitors say this park offers scenic hiking trails, a peaceful atmosphere, and opportunities for fishing and kayaking. They also highlight the well-maintained trails, abundance of parking, and friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-ae5d-71ab-96a1-c8d7aeeccd19.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic river and waterfall with autumn foliage.",
        "public_id": "019d72d1-ae5d-71ab-96a1-c8d7aeeccd19",
        "storage_key": "property/6767906449167444/019d72d1-ae5d-71ab-96a1-c8d7aeeccd19.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://gastateparks.org/SweetwaterCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=11828929759375328263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sweetwater-creek-state-park",
      "poi_latitude": "33.7525384",
      "poi_longitude": "-84.628709",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-732-5871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-3016-7450-bb2e-42790e8783a7.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black Christmas tree icon",
        "public_id": "019d72d2-3016-7450-bb2e-42790e8783a7",
        "storage_key": "property/6767906449167444/019d72d2-3016-7450-bb2e-42790e8783a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm07D0ZQi9YgRBwSdnPHMKKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f4da922a-7aca-4a47-9b07-c63294eb32d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Deer Lick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2105 Mack Rd, Douglasville, GA 30135, USA",
      "poi_short_description": "Field sports, disc & mini-golf, tennis, a playground, fishing lake, picnic areas & an amphitheater.",
      "poi_long_description": "People say this park offers a paved walking trail, a lake with ducks and geese, and a little library stand. They highlight the clean bathrooms, wheelchair and stroller accessibility, and the peaceful and inviting atmosphere. They also like the thoughtful touches, such as the Blessing Box and artwork.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-ac69-717d-8828-2cbdaa82fa6c.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic pond with geese and a wooden deck surrounded by lush green trees.",
        "public_id": "019d72d1-ac69-717d-8828-2cbdaa82fa6c",
        "storage_key": "property/6767906449167444/019d72d1-ac69-717d-8828-2cbdaa82fa6c.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://www.celebratedouglascounty.com/Facilities/Facility/Details/Deer-Lick-Park-17",
      "poi_directions_map_url": "https://maps.google.com/?cid=12787023810962926613&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "deer-lick-park",
      "poi_latitude": "33.7472957",
      "poi_longitude": "-84.6845365",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-920-7129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-3016-7450-bb2e-42790e8783a7.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black Christmas tree icon",
        "public_id": "019d72d2-3016-7450-bb2e-42790e8783a7",
        "storage_key": "property/6767906449167444/019d72d2-3016-7450-bb2e-42790e8783a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC5aqAzYh9YgRFSzoUmiidLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e7a5a865-a9e4-4d05-b7ee-673e0cc83538",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Jessie Davis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7775 Jessie Davis Pk Dr, Douglasville, GA 30134, USA",
      "poi_short_description": "Relaxed park featuring baseball fields, basketball courts, a playground and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-c18a-717b-9fad-b179ab795710.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor picnic shelter and swimming pool area",
        "public_id": "019d72d1-c18a-717b-9fad-b179ab795710",
        "storage_key": "property/6767906449167444/019d72d1-c18a-717b-9fad-b179ab795710.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.douglasvilleparks.com/Parks/Jessie-G.-Davis-Memorial-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=985096381796348482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jessie-davis-park",
      "poi_latitude": "33.765477",
      "poi_longitude": "-84.747036",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-920-3009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-3016-7450-bb2e-42790e8783a7.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black Christmas tree icon",
        "public_id": "019d72d2-3016-7450-bb2e-42790e8783a7",
        "storage_key": "property/6767906449167444/019d72d2-3016-7450-bb2e-42790e8783a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxspgHEm9YgRQnJ-ovDDqw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0f5e77b0-386d-428f-8f8f-6bd60daafd69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Wallace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6289 Pisgah Rd SW, Austell, GA 30168, USA",
      "poi_short_description": "Community park with a playground, sports facilities, and picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-b9a2-75be-a87f-8005e8a6c95d.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides, climbing structures, and a merry-go-round.",
        "public_id": "019d72d1-b9a2-75be-a87f-8005e8a6c95d",
        "storage_key": "property/6767906449167444/019d72d1-b9a2-75be-a87f-8005e8a6c95d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.cobbcounty.org/parks/parks-and-nature/locations/wallace-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6891181814003162099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wallace-park",
      "poi_latitude": "33.7996519",
      "poi_longitude": "-84.5847089",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-819-3233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-3016-7450-bb2e-42790e8783a7.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black Christmas tree icon",
        "public_id": "019d72d2-3016-7450-bb2e-42790e8783a7",
        "storage_key": "property/6767906449167444/019d72d2-3016-7450-bb2e-42790e8783a7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98bJIe0Y9YgR81tKSlllol8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_24feda1a-4083-4750-8408-fff5c3c1d0d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Chapel Hills Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3300 Golf Ridge Blvd, Douglasville, GA 30135, USA",
      "poi_short_description": "Golf facility offering 36 holes, a pool, and tennis, plus dining and event options.",
      "poi_long_description": "People say this golf course has a great layout and the greens are always in good shape. They highlight the course is beautiful and fun to play, and the staff can be awesome. They also like the great lunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-ced7-704a-bb67-81e27a3142ed.webp",
      "poi_featured_image_media": {
        "alt_text": "Golf course with pink azaleas in bloom and a putting green with a flag.",
        "public_id": "019d72d1-ced7-704a-bb67-81e27a3142ed",
        "storage_key": "property/6767906449167444/019d72d1-ced7-704a-bb67-81e27a3142ed.webp",
        "width": 2700,
        "height": 903
      },
      "poi_business_url": "http://chapelhillsgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11318276731031941445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chapel-hills-golf-club",
      "poi_latitude": "33.7162952",
      "poi_longitude": "-84.7255186",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-949-0030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-3008-7170-8488-176d2ae884be.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing a person playing soccer.",
        "public_id": "019d72d2-3008-7170-8488-176d2ae884be",
        "storage_key": "property/6767906449167444/019d72d2-3008-7170-8488-176d2ae884be.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJqVtq1Acn9YgRRXG6VriYEp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_09299be9-0537-4d86-a1ec-2e926f5f82b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Switch ATLANTA - The Keep Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Switch Wy, Lithia Springs, GA 30122, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-d578-7132-8e33-2abe977a9fa2.webp",
      "poi_featured_image_media": {
        "alt_text": "Switch data center facility entrance and exterior with red and white accents under a blue sky with clouds.",
        "public_id": "019d72d1-d578-7132-8e33-2abe977a9fa2",
        "storage_key": "property/6767906449167444/019d72d1-d578-7132-8e33-2abe977a9fa2.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.switch.com/atlanta/?utm_source=google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=9766611684943951474&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "switch-atlanta---the-keep-campus",
      "poi_latitude": "33.7548561",
      "poi_longitude": "-84.5872802",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 877-775-4774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU9z7a4Ef9YgRcnZD7JT5iYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bb6fc743-0662-4424-9849-df33f53cf2f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Iuec Local 32",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1492 Blair Bridge Rd, Austell, GA 30168, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.iueclocal32.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13523304514346315580&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iuec-local-32",
      "poi_latitude": "33.7808597",
      "poi_longitude": "-84.59843479999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-378-6208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV61JpKUY9YgRPG8MZ85trLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_10c4f91f-38e1-4263-b6f6-a29a689416f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "City of South Fulton",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5440 Fulton Industrial Blvd SW, Atlanta, GA 30336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-d388-74ad-aae1-1bea47dae08a.webp",
      "poi_featured_image_media": {
        "alt_text": "Sign for City of South Fulton City Hall at 5440.",
        "public_id": "019d72d1-d388-74ad-aae1-1bea47dae08a",
        "storage_key": "property/6767906449167444/019d72d1-d388-74ad-aae1-1bea47dae08a.webp",
        "width": 1341,
        "height": 1393
      },
      "poi_business_url": "http://www.cityofsouthfultonga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15167539311348359537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-south-fulton",
      "poi_latitude": "33.738129",
      "poi_longitude": "-84.56454769999999",
      "poi_miles_from_property": "14.2",
      "poi_walking_minutes": "5 hours 15 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 470-552-4311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-3784-752c-beca-6f4b32c3389c.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d72d2-3784-752c-beca-6f4b32c3389c",
        "storage_key": "property/6767906449167444/019d72d2-3784-752c-beca-6f4b32c3389c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcY74B-Ie9YgRcSGxgaTsfdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_bf187de6-00b6-4f64-8981-ff54bd85890f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Geiger Furniture",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6095 Fulton Industrial Blvd SW, Atlanta, GA 30336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-f2b7-73ad-b89e-0652b37f278b.webp",
      "poi_featured_image_media": {
        "alt_text": "Warehouse interior with stacked boxes and shelves.",
        "public_id": "019d72d1-f2b7-73ad-b89e-0652b37f278b",
        "storage_key": "property/6767906449167444/019d72d1-f2b7-73ad-b89e-0652b37f278b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.geigerfurniture.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11411867909374933109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "geiger-furniture",
      "poi_latitude": "33.71581210000001",
      "poi_longitude": "-84.5882184",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-456-6452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVhjJpkf9YgRdfj4oWYZX54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7415c1b5-2b06-4f28-939f-2e5bd1bcfedb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "poi_name": "Mellow Mushroom Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5375 Drake Dr SW, Atlanta, GA 30336, USA",
      "poi_short_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_long_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-f0c1-712b-b51f-59acf474ba81.webp",
      "poi_featured_image_media": {
        "alt_text": "Delicious pizza slices with toppings and text 'Happiness as expressed in Pizza'.",
        "public_id": "019d72d1-f0c1-712b-b51f-59acf474ba81",
        "storage_key": "property/6767906449167444/019d72d1-f0c1-712b-b51f-59acf474ba81.webp",
        "width": 960,
        "height": 400
      },
      "poi_business_url": "http://www.mellowmushroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=171316785737644382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mellow-mushroom-headquarters",
      "poi_latitude": "33.7466712",
      "poi_longitude": "-84.5626277",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-505-2801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d72d2-2f55-772d-979e-477313b77dc0",
        "storage_key": "property/6767906449167444/019d72d2-2f55-772d-979e-477313b77dc0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE5SKnt8e9YgRXjn0fbWjYAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_00297c60ebb357c612e16c9e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3d085e7c16504721d18c061b",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bec35d56d54122670459d611",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_28e8d5f5a80811f212199246",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ceee591b9a18c1988c56f39e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f798ac41e7304a045bae91c4",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_57390213f7726541d5277c72",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "rating": "5",
      "name": "Renee",
      "text": "Love our community, new management is great, always helping and supporting residents. Making sure residents have a safe quiet and beautiful community, customer service great\nMaintenance great, office staff great, amenities amazing, hounds beautiful and we have amazing resident events. Amazing simply a hidden gem right off of I20 west. Absolutely wonderful staff. The new management is simply fantastic. Amazing summer community fun",
      "date": "2026-06-28",
      "title": "false"
    },
    {
      "id": "ec_fe4871d658c0f6be589464c3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "rating": "5",
      "name": "Trystin Berry",
      "text": "I recently went on a tour here and I was thoroughly impressed. The property is beautiful, quiet, modern, and well maintained. Keisha’s customer service was professional and she is always happy to pick up when you call to ask questions.",
      "date": "2026-05-19",
      "title": "false"
    },
    {
      "id": "ec_9d7dc88acb9454b9cb01bf3e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "rating": "4",
      "name": "Dorlene Amponsah",
      "text": "I am not someone who typically leaves reviews, but after living here for a year, I felt it was a good opportunity to share my honest experience. Overall, this is a very nice apartment community. My husband and I truly enjoy the amenities that are offered. The community itself is pretty easy going.\n\nThat being said, we felt that certain aspects of the resident experience were smoother under the previous management team. We rarely had any concerns, but when issues did arise, maintenance was exceptional, communication was prompt, and management was highly responsive. Even the maintenance team we had was exceptional!\n\nSince the transition to the new management team earlier this year, it has taken some adjustment. While the office staff are professional, direct, and straightforward, which I appreciate, I believe there is room for improvement when it comes to communication. On some occasions, I have sent emails regarding important matters and have not received a timely response. In many cases, I have had to send follow-up emails, even just recently, I sent an email last week and this week with no response yet. Me and my husband don't always have the flexibility to stop by the office due to work.\n\nAlthough these concerns have not overshadowed our overall positive experience, consistent and responsive communication is important to residents. I believe improving this area would greatly enhance the experience for current and future tenants.\n\nOverall, this is still a great place to live, and I hope to see continued improvements as the new management team strengthens themselves in their roles over time.",
      "date": "2026-06-12",
      "title": "false"
    },
    {
      "id": "ec_f84b34af165a3bab3c36624d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "rating": "5",
      "name": "Keir Seabrooks",
      "text": "My experience with Michelle was absolutely amazing! Thank you so much for assisting me in finding a place to call home. I rarely leave reviews, but now that I’m settled, I can’t stop thinking about how wonderful it was to meet her.\n\nMichelle, you are truly incredible! Keep that spark ; it shines through in everything you do. I’ve visited many properties, and I have never experienced hospitality like this before.\nThank you for making this such a positive and memorable experience!",
      "date": "2026-01-17",
      "title": "false"
    },
    {
      "id": "ec_a93883c860d42f55a2c03ec1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "rating": "5",
      "name": "Mareshia Leach",
      "text": "I truly want to thank Ms. Tori for her kindness and outstanding customer service during a very stressful moment for me. There was a spider on my door while I was holding my baby, and I was completely terrified and unsure of what to do. After contacting the leasing office, Ms. Tori came to my building right away to help.\n\nShe was so understanding and compassionate about how scared I was, and without hesitation, she used a broom to remove the spider from my door. It may seem like a small act to some, but in that moment, her willingness to help meant so much to me. Her patience, kindness, and professionalism truly went above and beyond.\n\nI sincerely appreciate her for taking the time to help and making me feel supported and safe. Ms. Tori deserves recognition for her exceptional customer service, and I would gladly give her five stars. Thank you !!",
      "date": "2026-05-27",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_31ccd13b6acc4334d5018faa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-5484-72ff-888c-99ceb83213f6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d72d1-5484-72ff-888c-99ceb83213f6",
        "storage_key": "property/6767906449167444/019d72d1-5484-72ff-888c-99ceb83213f6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Novo - 1 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=m3gkvBRUPGE&play=1"
    },
    {
      "id": "ec_b65dd87b4f528c8241f29b07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-5487-7140-8170-96848f678b58.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d72d1-5487-7140-8170-96848f678b58",
        "storage_key": "property/6767906449167444/019d72d1-5487-7140-8170-96848f678b58.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Novo - 2 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wPG8V9oSTDg&play=1"
    },
    {
      "id": "ec_030451a0804efecb5d8f06e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-56cb-75a4-9ace-191e5ed37314.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d72d1-56cb-75a4-9ace-191e5ed37314",
        "storage_key": "property/6767906449167444/019d72d1-56cb-75a4-9ace-191e5ed37314.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Novo - 3 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=g8eMAh6pedt&play=1"
    },
    {
      "id": "ec_5ce2060e0d5fa3d2b9c57140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-754f-737c-bf7a-b35504d00968.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d72d1-754f-737c-bf7a-b35504d00968",
        "storage_key": "property/6767906449167444/019d72d1-754f-737c-bf7a-b35504d00968.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "NOVO Sweetwater Amenity Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Jb8S2TTf5CH&play=1"
    },
    {
      "id": "ec_261e644cb54daedd54e6ca1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167444/019d72d1-755c-7529-9716-f2c457aaafd9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d72d1-755c-7529-9716-f2c457aaafd9",
        "storage_key": "property/6767906449167444/019d72d1-755c-7529-9716-f2c457aaafd9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "NOVO Sweetwater - Clubhouse & Fitness",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mkcE4NdmeGx&play=1"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-dd3b-77ba-9732-706928b8f7f0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Novo Sweetwater Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444"
    },
    {
      "lead_collector_id": "019db23f-ddb1-7674-87cd-88819ab05ac2",
      "lead_source": "FACEBOOK_ADS",
      "name": "Novo Sweetwater Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444"
    },
    {
      "lead_collector_id": "019db23f-de26-769c-b599-c77b4337d52d",
      "lead_source": "LANDING_PAGE",
      "name": "Novo Sweetwater Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "resort-style-pool-apartments-lithia-springs",
      "search_query": "apartments with resort-style pool Lithia Springs",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments",
      "h2_subtitle": "Discover premium apartments with a resort-style pool in Lithia Springs. Experience luxury living in the heart of the city.",
      "page_copy": "Experience the pinnacle of luxury living at NOVO Sweetwater, offering not just a home but a lifestyle. Our community features exclusive amenities including a resort-style pool, ideal for relaxation and unwinding after a long day. Nestled in the vibrant Lithia Springs, it's the perfect place for those who value both comfort and convenience.\n\nOur Lithia Springs apartment homes are designed with modern touches such as wood-style flooring, catering to those with a refined taste. Importantly, NOVO Sweetwater is more than just a place to live; it's a place to thrive. Enjoy access to our state-of-the-art fitness center and PupPlay Park, providing spaces for both fitness enthusiasts and pet lovers. Discover unparalleled living at our resort-style pool apartments today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments in Lithia Springs",
      "seo_description": "Explore NOVO Sweetwater's resort-style pool apartments in Lithia Springs, offering luxurious amenities for premium living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-douglas-county",
      "search_query": "state-of-the-art fitness center apartments Douglas County",
      "category": "Amenity",
      "h1_title": "Fitness-Focused Apartments in Douglas County",
      "h2_subtitle": "Explore apartments with a state-of-the-art fitness center in Douglas County. Live where health and luxury converge.",
      "page_copy": "At NOVO Sweetwater, we understand the modern resident's need for convenience and well-being. Our community in Douglas County is equipped with a state-of-the-art fitness center, designed to meet all your health and exercise needs right at home. Skip the gym crowds and enjoy the luxury of a private fitness experience within your apartment complex.\n\nIn addition to our advanced fitness facilities, residents at NOVO Sweetwater enjoy a variety of upscale amenities, such as wood-style flooring, high-speed internet, and a PupPlay Park for furry friends. Set in the vibrant Lithia Springs area, our community combines modern living with the natural beauty of Douglas County, offering a lifestyle where wellness and luxury meet.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Douglas County",
      "seo_description": "Discover NOVO Sweetwater in Douglas County, featuring a state-of-the-art fitness center among other luxury amenities for a balanced lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "pet-friendly-dog-park-apartments-lithia-springs",
      "search_query": "pet-friendly apartments with dog park Lithia Springs GA",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Lithia Springs",
      "h2_subtitle": "Discover pet-friendly apartments with a dog park in Lithia Springs, GA. Enjoy a community where pets are part of the family.",
      "page_copy": "At NOVO Sweetwater, we know how important your furry friends are. That's why our pet-friendly community in Lithia Springs, GA, features a dedicated PupPlay Park, ideal for playful outings and socializing with fellow pups. Our apartments welcome you and your pets to a community that truly feels like home.\n\nAlongside our fantastic dog park, residents enjoy modern amenities like wood-style flooring and lightning-fast high-speed internet. Our state-of-the-art fitness center offers a convenient workout solution, while the centralized mail hub ensures hassle-free package pickups. Experience the perfect blend of pet-friendly living and top-tier amenities at NOVO Sweetwater.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park in Lithia Springs",
      "seo_description": "Find your dream pet-friendly apartment in Lithia Springs with a dog park. NOVO Sweetwater offers the perfect environment for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "luxury-apartments-stainless-steel-30122",
      "search_query": "luxury apartments with stainless steel appliances 30122",
      "category": "Amenity",
      "h1_title": "Luxury Apartments in 30122",
      "h2_subtitle": "Explore luxury apartments with stainless steel appliances in the 30122 area. Enjoy modern living in a premium location.",
      "page_copy": "Welcome to NOVO Sweetwater, where luxury meets modern convenience in the heart of Lithia Springs. Our apartments boast stainless steel appliances, offering a sleek and contemporary kitchen experience. Designed for those with a taste for elegance, our homes perfectly blend functionality and style.\n\nLocated in the vibrant 30122 area, residents enjoy not just the luxurious living spaces but also a plethora of amenities, including wood-style flooring and a state-of-the-art fitness center. Our community fosters a sense of belonging with features like a centralized mail hub and a PupPlay Park, ensuring that all residents, including pets, feel right at home. Discover the art of upscale living at NOVO Sweetwater.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Stainless Steel in 30122",
      "seo_description": "Discover luxury living in 30122. NOVO Sweetwater offers apartments with stainless steel appliances and upscale amenities for a chic lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-lithia-springs",
      "search_query": "in-unit laundry apartments Lithia Springs GA",
      "category": "Amenity",
      "h1_title": "Convenient In-Unit Laundry in Lithia Springs",
      "h2_subtitle": "Find apartments with in-unit laundry in Lithia Springs, GA. Enjoy the ease and comfort of laundry at home.",
      "page_copy": "NOVO Sweetwater in Lithia Springs, GA, offers the ultimate convenience with in-unit laundry facilities, ensuring a hassle-free living experience. No more trips to the laundromat or waiting in line; enjoy the privacy and efficiency of doing laundry in your own space.\n\nBeyond the in-unit amenities, our community enriches your lifestyle with a state-of-the-art fitness center, high-speed internet, and a centralized mail hub for all your delivery needs. Pets are welcome too, with our dedicated PupPlay Park available for their enjoyment. Experience life at its most convenient and engaging in Lithia Springs at NOVO Sweetwater.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Lithia Springs, GA",
      "seo_description": "Experience the convenience of in-unit laundry at NOVO Sweetwater. Premium apartments in Lithia Springs, GA, with a suite of luxury features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-lithia-springs-ga",
      "search_query": "one bedroom apartments Lithia Springs GA",
      "category": "Floorplan",
      "h1_title": "Modern One Bedroom Apartments in Lithia Springs",
      "h2_subtitle": "Explore spacious one-bedroom apartments in Lithia Springs, GA. Perfect for anyone seeking a comfortable home.",
      "page_copy": "NOVO Sweetwater offers one-bedroom apartment homes in Lithia Springs, GA. These apartment homes feature spacious layouts, modern finishes, and practical apartment amenities.\n\nCommunity amenities include high-speed internet access, a fitness center, a centralized mail hub, and a PupPlay Park. NOVO Sweetwater combines modern apartment conveniences with pet-friendly community features and convenient access to local attractions throughout Lithia Springs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Lithia Springs, GA",
      "seo_description": "Find modern one bedroom apartments at NOVO Sweetwater in Lithia Springs, GA, with premium amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-douglas-county",
      "search_query": "two bedroom apartments Douglas County",
      "category": "Floorplan",
      "h1_title": "Spacious Two Bedroom Apartments in Douglas County",
      "h2_subtitle": "Discover two-bedroom apartments in Douglas County, perfect for anyone seeking modern living spaces.",
      "page_copy": "NOVO Sweetwater offers two-bedroom apartment homes in Douglas County with additional living space, flexible layouts, and modern conveniences. These apartment homes feature wood-style flooring, high-speed internet access, and practical apartment amenities.\n\nCommunity amenities include a fitness center and PupPlay Park. Located in Lithia Springs, NOVO Sweetwater combines modern apartment features with pet-friendly community amenities and convenient access to local attractions and services throughout Douglas County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Douglas County",
      "seo_description": "Explore two-bedroom apartments at NOVO Sweetwater in Douglas County. Spacious, modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-30122",
      "search_query": "three bedroom apartments near 30122",
      "category": "Floorplan",
      "h1_title": "Elegant Three Bedroom Apartments Near 30122",
      "h2_subtitle": "Explore three-bedroom apartments near the 30122 area. Ideal for anyone needing space and premium amenities.",
      "page_copy": "NOVO Sweetwater offers three-bedroom apartment homes near the 30122 area. These floor plans provide additional living space, flexible layouts, and modern apartment amenities.\n\nCommunity amenities include a fitness center, high-speed internet access, and a PupPlay Park. NOVO Sweetwater combines modern apartment features with pet-friendly community amenities and convenient access to local attractions and services throughout Lithia Springs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 30122",
      "seo_description": "Find elegant three bedroom apartments at NOVO Sweetwater near 30122. Enjoy spacious living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "apartments-near-wellstar-douglas-medical-center",
      "search_query": "apartments near wellstar douglas medical center lithia springs",
      "category": "Hospital",
      "h1_title": "Convenient Apartments Near Wellstar Douglas",
      "h2_subtitle": "Discover apartments near Wellstar Douglas Medical Center in Lithia Springs. Ideal for anyone seeking proximity and comfort.",
      "page_copy": "NOVO Sweetwater offers apartment homes conveniently located near Wellstar Douglas Medical Center in Lithia Springs. The community provides convenient access to healthcare facilities, local services, shopping, dining, and other nearby amenities.\n\nCommunity amenities include high-speed internet access, a fitness center, a centralized mail hub, and a PupPlay Park. NOVO Sweetwater combines modern apartment amenities with pet-friendly community features and a convenient location near Wellstar Douglas Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wellstar Douglas Medical Center",
      "seo_description": "Find convenient apartments at NOVO Sweetwater near Wellstar Douglas Medical Center in Lithia Springs. Perfect for anyone seeking comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "apartments-near-sweetwater-creek-state-park",
      "search_query": "apartments near sweetwater creek state park lithia springs",
      "category": "Park",
      "h1_title": "Live Near Sweetwater Creek State Park",
      "h2_subtitle": "Explore apartments near Sweetwater Creek State Park in Lithia Springs. Perfect for nature lovers and adventure seekers.",
      "page_copy": "Located just a short distance from Sweetwater Creek State Park, NOVO Sweetwater offers an ideal home for those who love nature and the outdoors. Our apartments are perfect for residents who enjoy hiking, fishing, or merely relaxing amidst the beauty of nature.\n\nIn addition to our great location, our community provides a variety of upscale amenities, such as a state-of-the-art fitness center and wood-style flooring. With high-speed internet and a welcoming PupPlay Park, you’ll find everything you need for a comfortable and active lifestyle. Choose NOVO Sweetwater for a truly enriching living experience near one of Georgia's most scenic parks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sweetwater Creek State Park",
      "seo_description": "Discover NOVO Sweetwater's apartments near Sweetwater Creek State Park in Lithia Springs. Ideal for nature enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "apartments-close-to-deer-lick-park-douglas-county",
      "search_query": "apartments close to deer lick park douglas county",
      "category": "Park",
      "h1_title": "Cozy Apartments Close to Deer Lick Park",
      "h2_subtitle": "Discover charming apartments close to Deer Lick Park in Douglas County.  ",
      "page_copy": "NOVO Sweetwater offers apartment homes conveniently located near Deer Lick Park in Douglas County. The community provides convenient access to outdoor recreation opportunities, green space, and nearby local amenities.\n\nCommunity features include a fitness center, wood-style flooring, pet-friendly amenities, and a PupPlay Park. NOVO Sweetwater combines modern apartment amenities with convenient access to Deer Lick Park and other local attractions throughout Douglas County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Deer Lick Park",
      "seo_description": "Find cozy apartments near Deer Lick Park in Douglas County at NOVO Sweetwater.  ",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "lithia-springs-apartments-by-jessie-davis-park",
      "search_query": "lithia springs apartments by jessie davis park",
      "category": "Park",
      "h1_title": "Charming Apartments by Jessie Davis Park",
      "h2_subtitle": "Experience vibrant living in Lithia Springs, with apartments By Jessie Davis Park. Perfect for those who love community and convenience.",
      "page_copy": "NOVO Sweetwater offers beautifully designed apartments in close proximity to Jessie Davis Park in Lithia Springs. Our community is perfect for those who want quick access to lush green spaces, walking trails, and community events.\n\nEach apartment features modern amenities such as high-speed internet and wood-style flooring. Residents can enjoy a workout in our state-of-the-art fitness center or socialize with neighbors at the PupPlay Park. NOVO Sweetwater combines comfort and location, providing an inviting home for anyone seeking serenity and a connected lifestyle near Jessie Davis Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Jessie Davis Park",
      "seo_description": "Discover comfortable Lithia Springs apartments by Jessie Davis Park at NOVO Sweetwater. Ideal for those seeking community and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167444",
      "source": "custom",
      "page_item_url": "wallace-park-apartments-lithia-springs-ga",
      "search_query": "nearby wallace park apartments lithia springs ga",
      "category": "Park",
      "h1_title": "Stylish Apartments Near Wallace Park",
      "h2_subtitle": "Find stylish apartments near Wallace Park in Lithia Springs, GA. Perfect for those who value convenience and modern living.",
      "page_copy": "Discover the comfort and style of NOVO Sweetwater, located just minutes from Wallace Park in Lithia Springs, GA. Our sophisticated apartments are ideal for those who appreciate easy access to lush parks and community amenities.\n\nEnjoy an array of modern features, including wood-style flooring and a high-speed internet connection. Dive into an active lifestyle with our state-of-the-art fitness center or unwind at our centralized mail hub. At NOVO Sweetwater, you’ll find a perfect blend of nature and convenience, making it an ideal place to call home near Wallace Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wallace Park, Lithia Springs",
      "seo_description": "Explore NOVO Sweetwater's stylish Lithia Springs apartments near Wallace Park, GA. Experience comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6081"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671058931"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PJ6MJ5VT"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script>Object.assign(window, {websiteToken: 'ZVUgUEot9aFSkxYnFCyBiP7F', siteConfig: {clt_i: \"102052\", property_id: \"100160107\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f012059290e25f11"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "884272987"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "019bf4c796a74c0da273"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "3f4d1cea-e689-11f0-b8e2-7b529166620a"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4d1cea-e689-11f0-b8e2-7b529166620a/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImJvMUNoM2ZRWUZ4dWtodGFlbjZVUmc9PSIsInZhbHVlIjoiWHFDV0tMc1FPd05NR00rVTk3aUNiQT09IiwibWFjIjoiODRhMjBiMGY0ZDc0YzMxYjQ0YTQwYjQxYjAxYTk1M2EzNzRmYzYzODczZjcwOTk3ZGQ5ZDY5MTBiMDEyYzFjYiJ9"
    }
  ],
  "custom_qb_id": "6081",
  "custom_repli_id": "11671058931",
  "custom_google_gtm_id": "GTM-PJ6MJ5VT",
  "custom_entrata_chatbot": "<script>Object.assign(window, {websiteToken: 'ZVUgUEot9aFSkxYnFCyBiP7F', siteConfig: {clt_i: \"102052\", property_id: \"100160107\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>",
  "custom_knock_community_id": "f012059290e25f11",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "884272987",
  "custom_call_rail_account_hash": "019bf4c796a74c0da273",
  "custom_eliseai_building_token": "3f4d1cea-e689-11f0-b8e2-7b529166620a",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4d1cea-e689-11f0-b8e2-7b529166620a/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImJvMUNoM2ZRWUZ4dWtodGFlbjZVUmc9PSIsInZhbHVlIjoiWHFDV0tMc1FPd05NR00rVTk3aUNiQT09IiwibWFjIjoiODRhMjBiMGY0ZDc0YzMxYjQ0YTQwYjQxYjAxYTk1M2EzNzRmYzYzODczZjcwOTk3ZGQ5ZDY5MTBiMDEyYzFjYiJ9",
  "custom_audioeye_site_id": "4f44076b-70f4-4c15-a800-a949b72f0a9e",
  "custom_audioeye_site_hash": "99eb6a3e839bddcbc63a7e98c8b4e99c"
};

export const generatedAt = '2026-10-01T17:22:54.059Z';
